import React from 'react';
import L from 'leaflet';
import 'leaflet-draw';
import Moment from 'moment';
import MaterialIcon from './../../components/MaterialIcon';
import PropTypes, { element } from 'prop-types';

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import Skeleton from '@material-ui/lab/Skeleton';

import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import CloseIcon from '@material-ui/icons/Close';
import RestartIcon from '@material-ui/icons/YoutubeSearchedFor';
import UpdateIcon from '@material-ui/icons/Update';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FilterDramaIcon from '@material-ui/icons/FilterDrama';
import NavigationIcon from '@material-ui/icons/Navigation';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import SpeedIcon from '@material-ui/icons/Speed';

import Chart from 'chart.js/auto';

import { notification } from 'antd';

import img from '../point/img';
import Config from '../../constants/appConfig';
import geo from '../../components/util/geo';
import tools from '../../components/util/tools';

import rainOn from '../../assets/images/rainOn.png';
import rainOff from '../../assets/images/rain.png';
import solarOn from '../../assets/images/solarOn.png';
import solarOff from '../../assets/images/solar.png';
import thermalInversionExample from '../../assets/images/thermalInversionExample.png';
import normalFlowExample from '../../assets/images/normalFlowExample.png';
import cloud from '../../assets/images/cloud.png';
import sun from '../../assets/images/sun.png';
import pressureForecast from '../../assets/images/pressureForecast.png';
import humidityForecast from '../../assets/images/humidityForecast.png';
import temperatureForecast from '../../assets/images/temperatureForecast.png';
import windDirectionForecast from '../../assets/images/windDirectionForecast.png';
import windSpeedForecast from '../../assets/images/windSpeedForecast.png';
import rainForecast from '../../assets/images/rainForecast.png';
import rainDay from '../../assets/images/rainDay.png';
import rainNight from '../../assets/images/rainNight.png';
import lua from '../../assets/images/lua.png';
import chuva from '../../assets/images/chuva.png';
import thermalInversion from '../../assets/images/thermalInversion.png';
import latitude from '../../assets/images/latitude.png';
import longitude from '../../assets/images/longitude.png';
import pressure from '../../assets/images/pressure.png';
import altitude from '../../assets/images/altitude.png';
import weatherData from '../../assets/images/weatherData.png';
import condicoes_climaticas from '../../assets/images/condicoes_climaticas.png';

import DeltaTHeat from '../../components/heat_graph/deltaTGraph';

import './style.css';
import { TextRotationAngledownSharp } from '@material-ui/icons';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
    },
    secondary: {
        backgroundColor: '#2D3238',
    },
    primary: {
        backgroundColor: '#3f51b5',
    },
    tooltip: {
        maxWidth: 'none',
        padding: 0,
    },
    customTooltip: {
        maxWidth: 'none',
        padding: 0,
    },
    label: {
        textAlign: 'left',
        paddingBottom: '0.75rem',
    },
    input: {
        textAlign: 'center',
        paddingTop: '0.75rem',
    },
    inputStyle: {
        '& label.Mui-focused': {
            color: 'rgb(250, 125, 52)',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'rgb(250, 125, 52)',
        },
        '& .MuiInput-input': {
            color: 'white',
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: 'white',
        },
        '& .MuiInputLabel-root': {
            color: 'rgb(250, 125, 52)',
        },
    },
    popUpButton: {
        color: 'rgb(250, 125, 52)',
        border: `1px solid rgb(250, 125, 52)`,
        '&:hover': {
            color: 'rgb(250, 125, 52)',
        },
    },
    disabledButton: {
        backgroundColor: 'rgb(255 255 255 / 26%)',
        cursor: 'not-allowed',
        border: 'none',
        boxShadow: 'none'
    },
    customWidthTooltip: {
        maxWidth: 500,
    },
    tab: {
        minWidth: '5rem',
        padding: '0 0.25rem',
        backgroundColor: 'rgb(32 35 39)',
        color: 'white',
        '&.Mui-selected': {
            backgroundColor: '#FA7D34',
            color: '#ffffff',
            borderRadius: '2rem'
        },
    },
    tabDisabled: {
        minWidth: '5rem',
        padding: '0 0.25rem',
        backgroundColor: 'rgb(32 35 39)',
        color: 'gray',
    },
    tabsIndicator: {
        display: 'none',
    },
    inputDate: {
        '& input': {
            color: 'white',
        },
        '&:before': {
            borderBottom: '1px solid white',
        },
        '&:hover:not(.Mui-disabled):before': {
            borderBottom: '2px solid white',
        },
        '&:after': {
            borderBottom: '2px solid #FA7D34',
        },
        '& .MuiSvgIcon-root': {
            color: 'white',
        },
        '& .MuiInputAdornment-root .MuiSvgIcon-root': {
            color: 'white',
        },
    },
    expandedMapStyles: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        margin: 0,
        padding: 0,
        overflow: 'hidden',
    },
    buttonNormalStyles: {
        zIndex: 10000
    },
    buttonFullScreenStyles: {
        position: 'fixed',
        top: '1rem',
        right: '1rem',
        zIndex: 10000
    },
    mapCommonStyle: {
        width: '100%',
        height: '100%',
        borderRadius: '1rem',
        transition: 'border-radius 0.3s',
        border: 'none',
    },
    select: {
        margin: '0 1rem',
        width: '12.5rem',
        color: 'white',
        '&:before': {
            borderBottom: '2px solid white',
        },
        '&:after': {
            borderBottom: '2px solid orange',
        },
    },
    icon: {
        color: 'white',
    },
    menuItem: {
        textAlign: 'center',
        color: 'black',
    },
});

class WeatherCoordinate {
    constructor() {
        this.latForecast = '';
        this.lngForecast = '';
    }
}

class WeatherData {
    constructor() {
        this.lat = '';
        this.lng = '';
        this.height = '';
        this.datetime = '';
        this.pressure = '';
        this.humidity = '';
        this.air_humidity = '';
        this.temperature = '';
        this.air_temperature = '';
        this.wind_direction = '';
        this.wind_speed = '';
        this.data_plus = '';
        this.rain = '';
        this.solar = '';
        this.chartRef = React.createRef();
    }
}

class Map extends React.Component {
    constructor(props) {
        super(props);
        const today = new Date();
        const currentMonth = (today.getMonth() + 1).toString().padStart(2, '0');
        const currentYear = today.getFullYear();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 6);

        this.state = {
            stations: [],
            stationData: [],
            idStationSelected: '',
            goTo: false,
            nameL: '',
            heightL: '',
            idL: '',
            idSourceL: '',
            idCompanyL: '',
            datetimeL: '',
            pressureL: '',
            humidityL: '',
            air_humidityL: '',
            temperatureL: '',
            air_temperatureL: '',
            wind_directionL: '',
            wind_speedL: '',
            windSpeedUnit: this.props.res.KMH,
            currentChart: null,
            delta_tL: '',
            rainL: '',
            solarL: '',
            addressStationL: '',
            thermalInversionL: '',
            lat: { value: '', error: false, input: '' },
            lng: { value: '', error: false, input: '' },
            latL: { value: '', error: false, input: '' },
            lngL: { value: '', error: false, input: '' },
            latitudeForecast: { value: '', error: false, input: '' },
            longitudeForecast: { value: '', error: false, input: '' },
            selectedDate: this.getLocalDate(),
            maxSelectedDate: new Date().toISOString().split('T')[0],
            selectedMonth: `${currentYear}-${currentMonth}`,
            selectedYear: currentYear.toString(),
            selectedWeekStart: sevenDaysAgo.toISOString().split('T')[0],
            selectedWeekEnd: today.toISOString().split('T')[0],
            selectedHistoricType: 'daily',
            selectedInfo: 'weatherChart',
            selectedStation: '',
            filterStations: [],
            filterStationData: [],
            stationName: '',
            flightConditions: '',
            autoUpdate: true,
            autoUpdateTimer: null,
            loading: true,
            isLoading: true,
            selectedTime: '',
            sliderData: [],
            weatherForecastData: [],
            weatherForecastCoordinate: [],
            consultForecastData: false,
            errorLocation: null,
            activeMarker: null,
            stationSelected: null,
            isOpenWeatherForecast: false,
            hoverForecast: false,
            isOpenStation: false,
            hasRain: '',
            hasSolar: '',
            noData: false,
            isMapExpanded: false,
            showData: true,
            monthlyData: [],
            yearlyData: [],
            weeklyData: [],
            refreshInterval: 300000,
        };

    };

    barChart = null;
    mymap = null;
    featureGroupP = null;
    tempMarker = null;
    drawCreateToolbar = null;

    componentDidMount = () => {
        const { autoUpdate, activeMarker } = this.state;
        this.existingIcons = {};

        const savedUnit = localStorage.getItem('windSpeedUnit') || this.props.res.KMH;
        const savedInterval = parseInt(localStorage.getItem('refreshInterval'), 10) || 300000;

        this.setState({ windSpeedUnit: savedUnit, refreshInterval: savedInterval });

        this.list_stations().then(() => {
            if (autoUpdate) {
                setTimeout(() => {
                    this.startAutoUpdate();
                }, 1500);
            }
        });

        this.icon = img;
        this.mymap = L.map('mapid', { zoomControl: false, attributionControl: false, maxZoom: 20 }).setView(Config.place, 14);
        let tileConfig = Object.assign({}, Config.tile_google_config, { maxZoom: 20 });
        L.tileLayer(Config.tile_google, tileConfig).addTo(this.mymap);

        this.featureGroupP = L.featureGroup().addTo(this.mymap);

        this.generateChart();

        this.mymap.on('draw:created', (e) => {
            let guid = tools.newGuid();
            e.layer.on("click", () => { this.handleClickP(e.layer, guid); });

            let tempMark = new WeatherCoordinate();
            tempMark.latForecast = e.layer._latlng.lat;
            tempMark.lngForecast = e.layer._latlng.lng;
            e.layer._leaflet_id = guid;
            const element = e.layer._latlng;

            if (activeMarker) {
                this.mymap.removeLayer(activeMarker);
            }

            let iconUrl = this.icon[24].img;
            let customIcon = L.icon({
                iconUrl: iconUrl,
                iconAnchor: [13, 33]
            });

            let newWeatherIcon = L.marker([element.lat, element.lng], { icon: customIcon }).addTo(this.mymap);

            this.setState({
                activeMarker: newWeatherIcon,
                latitudeForecast: { error: false, input: geo.toDMS(element.lat, 'latitude', 1), value: element.lat },
                longitudeForecast: { error: false, input: geo.toDMS(element.lng, 'longitude', 1), value: element.lng },
            });
        });

        if (navigator.geolocation) {
            const options = {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0,
            };

            navigator.geolocation.getCurrentPosition(
                this.handleSuccessLocation,
                this.handleErrorLocation,
                options
            );
        } else {
            this.setState({ errorLocation: this.props.res.LOCALIZACAO_NAO_ENCONTRADA });
        }
    };

    componentDidUpdate(prevProps, prevState) {
        const { selectedInfo, filterStations, latitudeForecast, longitudeForecast, monthlyData, yearlyData, weeklyData, loading } = this.state;
        if (selectedInfo !== prevState.selectedInfo) {
            if (filterStations.length > 0) {
                this.generateChart();
            } else if (monthlyData.length > 0) {
                this.generateMonthlyChart();
            } else if (yearlyData.length > 0) {
                this.generateYearlyChart();
            } else if (weeklyData.length > 0) {
                this.generateWeeklyChart();
            }
        }

        if (latitudeForecast !== prevState.latitudeForecast && longitudeForecast !== prevState.longitudeForecast) {
            this.setState({ consultForecastData: false });
        }

        if (prevState.windSpeedUnit !== this.state.windSpeedUnit) {
            this.renderCurrentChart();
        }

        if (prevState.loading && !loading) {
            // Chame a função handleFilterDate quando loading for false
            this.handleFilterDate();
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };

        clearInterval(this.timer);
    };

    startAutoUpdate = () => {
        const refreshInterval = this.state.refreshInterval;

        this.list_stations()
            .then(() => {
                this.setState({ selectedDate: this.getLocalDate() }, () => {
                    this.handleFilterDate();
                });

                const timer = setInterval(() => {
                    this.list_stations().then(() => {
                        this.setState({ selectedDate: this.getLocalDate() }, this.handleFilterDate);
                    });
                }, refreshInterval);

                this.setState({ autoUpdateTimer: timer });
            })
            .catch((error) => {
                console.error(error);
            });
    };

    stopAutoUpdate = () => {
        clearInterval(this.state.autoUpdateTimer);
    };

    handleIntervalChange = (event) => {
        const newInterval = parseInt(event.target.value, 10) * 60000;

        localStorage.setItem('refreshInterval', newInterval);

        this.setState({ refreshInterval: newInterval }, () => {
            if (this.state.autoUpdate) {
                this.stopAutoUpdate();
                this.startAutoUpdate();
            }
        });
    };

    getLocalDate = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    handleSuccessLocation = (position) => {
        const { activeMarker } = this.state;

        const userLatitude = position.coords.latitude;
        const userLongitude = position.coords.longitude;

        this.setState(
            {
                latitudeForecast: { error: false, input: geo.toDMS(userLatitude, 'latitude', 1), value: userLatitude },
                longitudeForecast: { error: false, input: geo.toDMS(userLongitude, 'longitude', 1), value: userLongitude },
            },
            () => {
                this.weatherForecast();

                if (activeMarker) {
                    this.mymap.removeLayer(activeMarker);
                }

                let iconUrl = this.icon[24].img;
                let customIcon = L.icon({
                    iconUrl: iconUrl,
                    iconAnchor: [13, 33],
                });
                let newWeatherIcon = L.marker([userLatitude, userLongitude], {
                    icon: customIcon,
                }).addTo(this.mymap);

                this.setState({ activeMarker: newWeatherIcon });
            }
        );
    };

    handleErrorLocation = (error) => {
        this.setState({ errorLocation: error.message });
    };

    consultForecast = () => {
        const { consultForecastData, activeMarker } = this.state;

        if (consultForecastData) {
            if (this.drawCreateToolbar) {
                this.drawCreateToolbar.disable();
            }
            this.setState({ consultForecastData: false });
        } else {
            let img = this.icon[24].img ? this.icon[24].img : this.icon[20].img;
            let dIcon = L.icon({
                iconUrl: img,
                iconAnchor: [13, 33]
            });

            if (!this.drawCreateToolbar) {
                this.drawCreateToolbar = new L.Draw.Marker(this.mymap, { icon: dIcon });
                this.mymap.on(L.Draw.Event.CREATED, (event) => {
                    if (activeMarker) {
                        this.mymap.removeLayer(activeMarker);
                    }
                    const { layer } = event;
                    this.mymap.addLayer(layer);
                    this.setState({
                        activeMarker: layer,
                        latitudeForecast: { error: false, value: layer.getLatLng().lat },
                        longitudeForecast: { error: false, value: layer.getLatLng().lng },
                    }, () => {
                        this.weatherForecast();
                    });
                });
            }

            this.drawCreateToolbar.enable();
            this.setState({ consultForecastData: true, goTo: false });
        }
    };

    zoomInL = () => {
        this.mymap.zoomIn();
    };

    zoomOutL = () => {
        this.mymap.zoomOut();
    };

    handleChangeCoordinates = (key) => (event) => {
        const { latitudeForecast, longitudeForecast } = this.state;
        const newValue = geo.toCoordinate(geo.toFixDMS(event.target.value));
        const valueDMS = event.target.value;
        this.validate(key, event.target.value);

        if (!isNaN(newValue)) {
            if (key === 'latitudeForecast') {
                this.setState({
                    latitudeForecast: {
                        ...latitudeForecast,
                        input: event.target.value,
                        value: newValue,
                        error: false,
                    },
                });
            } else if (key === 'longitudeForecast') {
                this.setState({
                    longitudeForecast: {
                        ...longitudeForecast,
                        input: event.target.value,
                        value: newValue,
                        error: false,
                    },
                });
            }

            this.updateWeatherIconPosition(valueDMS, newValue);
        } else {
            notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_COORDINATE,
                icon: <MaterialIcon icon="error" className="text-danger" />,
            });
        }
    };

    updateWeatherIconPosition = (valueDMS, newValue) => {
        const { activeMarker, latitudeForecast, longitudeForecast } = this.state;

        if (activeMarker) {
            if (latitudeForecast.input === valueDMS) {
                activeMarker.setLatLng([newValue, longitudeForecast.value]);
            } else if (longitudeForecast.input === valueDMS) {
                activeMarker.setLatLng([latitudeForecast.value, newValue]);
            }
        }
    };

    toggleAutoUpdate = () => {
        const { autoUpdate } = this.state;
        if (autoUpdate) {
            this.stopAutoUpdate();
        } else {
            this.setState({ selectedHistoricType: 'daily' })
            this.startAutoUpdate();
        }

        this.setState(prevState => ({
            autoUpdate: !prevState.autoUpdate,
        }));
    };

    drawMarker = (stationIcon) => {
        let dIcon = L.icon({
            iconUrl: stationIcon.img,
            iconAnchor: stationIcon.type === 'O' ? [25, 30] : [13, 33],
            popupAnchor: [0, -25],
        });
        let newLatLng = new L.LatLng(stationIcon.lat, stationIcon.lng);

        let existingIcon = this.existingIcons[stationIcon.id_source];

        if (existingIcon) {
            existingIcon.setLatLng(newLatLng);
            existingIcon.setIcon(dIcon);

            existingIcon.options.zIndexOffset = stationIcon.zIndex || 500;

            return;
        }

        let myLayer = L.marker(newLatLng, { icon: dIcon, zIndexOffset: stationIcon.zIndex || 500 });

        myLayer.on("click", () => { this.handleClickP(myLayer, stationIcon.id_source); });
        myLayer.addTo(this.featureGroupP);

        this.existingIcons[stationIcon.id_source] = myLayer;
    };

    validate = (name, value) => {
        let update = this.state[name];
        if (name === 'lat' || name === 'latL' || name === 'latitudeForecast') {
            update.input = value;
            if (/\d{1,2}(°|º)\d{1,2}'(\d{1,2}|\d{1,2}\.\d{1,4})( |")(N|S)/.test(value)) {
                update.value = geo.toCoordinate(geo.toFixDMS(value));
                update.error = false;
            } else {
                update.error = true;
            }
        } else if (name === 'lng' || name === 'lngL' || name === 'longitudeForecast') {
            update.input = value;
            if ((/\d{1,2}(°|º)\d{1,2}'(\d{1,2}|\d{1,2}\.\d{1,4})( |")(W|E)/.test(value))
                || (/\d{1,2}(°|º)\d{1,2}'(\d{1,2}|\d{1,2}\.\d{1,4})( |")(O|L)/.test(value))) {
                update.value = geo.toCoordinate(geo.toFixDMS(value));
                update.error = false;
            } else {
                update.error = true;
            }
        }

        this.setState(update);
    };

    showGoTo = () => {
        const { goTo } = this.state;
        if (goTo) {
            this.setState({ goTo: false });
        } else {
            let lat = { error: false, input: geo.toDMS(this.mymap.getCenter().lat, 'latitude', 1), value: this.mymap.getCenter().lat };
            let lng = { error: false, input: geo.toDMS(this.mymap.getCenter().lng, 'longitude', 1), value: this.mymap.getCenter().lng };
            this.setState({ goTo: true, lat, lng, consultForecastData: false });
            if (this.drawCreateToolbar) {
                this.drawCreateToolbar.disable();
            }
        }
    };

    showMapData = () => {
        const { showData } = this.state;
        if (showData) {
            this.setState({ showData: false });
        } else {
            this.setState({ showData: true });
        }
    };

    goToCoordinates = () => {
        const { lat, lng } = this.state;
        this.mymap.setView([lat.value, lng.value]);
        this.setState({ goTo: false });
    };

    list_stations = async () => {
        if (this.state.stations && this.state.stations.length > 0) {
            this.state.stations.forEach((item) => this.getDataById(item.id, item.name));
            return;
        }

        try {
            const apiUrl = Config.server + '/weather_source';
            const options = {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem('access-token-jwt')
                }
            };

            const res = await fetch(apiUrl, options);
            if (res.status !== 200) throw res;
            const result = await res.json();
            if (result.length > 0) {
                const mostRecentStation = result.reduce((mostRecent, station) =>
                    new Date(mostRecent.datetime) > new Date(station.datetime) ? mostRecent : station
                );

                this.setState({
                    stations: result,
                    idStationSelected: mostRecentStation.id
                }, () => {
                    result.forEach((item) => this.getDataById(item.id, item.name));
                });
            }
        } catch (error) {
            if (error.status === 405) {
                notification.open({
                    message: this.props.res.PERMISSAO,
                    description: this.props.res.PERMISSAO_MSG,
                    icon: <MaterialIcon icon="error" className="text-danger" />
                });
            } else if (error.status === 401 || error.status === 403) {
                this.props.link('/login');
            } else {
                notification.open({
                    message: this.props.res.ERRO,
                    description: this.props.res.ERRO_MSG,
                    icon: <MaterialIcon icon="error" className="text-danger" />
                });
            }
        }
    };

    handleClickP = (layer, id) => {
        const { idStationSelected, stationData } = this.state;
        if (id && id !== idStationSelected) {
            const selectedStation = stationData.find((item) => item.id_source === id);
            if (selectedStation) {
                this.setState({
                    idStationSelected: id,
                    goTo: false,
                    stationName: selectedStation.name,
                    consultForecastData: false
                });
                if (this.drawCreateToolbar) {
                    this.drawCreateToolbar.disable();
                }
            }

            for (let i = 0; i < stationData.length; i++) {
                const element = stationData[i];
                const deltaT = element.delta_t?.toFixed(1);

                let deltaTValue;
                if (deltaT != -99 && deltaT !== undefined && deltaT !== null) {
                    deltaTValue = deltaT;
                    if (deltaTValue >= 2 && deltaTValue <= 8) {
                        this.setState({ flightConditions: this.props.res.CONDICOES_ADEQUADAS });
                    } else if (deltaTValue > 10) {
                        this.setState({ flightConditions: this.props.res.CONDICOES_INADEQUADAS });
                    } else {
                        this.setState({ flightConditions: this.props.res.CONDICOES_ARRISCADAS });
                    }
                } else {
                    this.setState({ flightConditions: this.props.res.SEM_CONEXAO });
                }
                if (element.id_source === id) {
                    const newState = {
                        idL: element.id,
                        idCompanyL: element.id_company,
                        idSourceL: element.id_source,
                        latL: { error: false, input: geo.toDMS(element.lat, 'latitude', 1), value: element.lat },
                        lngL: { error: false, input: geo.toDMS(element.lng, 'longitude', 1), value: element.lng },
                        thermalInversionL: !element.temperature ? this.props.res.DESABILITADO
                            : Number(element.air_temperature) - (Number(element.temperature) + 3) > 0
                                ? this.props.res.GRANDES_INVERSÃO_TERMICA
                                : Number(element.air_temperature) - (Number(element.temperature) + 1) > 0
                                    ? this.props.res.PODE_ESTAR_INVERSÃO_TERMICA
                                    : this.props.res.NAO_INVERSÃO_TERMICA,
                        rainL: element.rain !== undefined ? element.rain : this.props.res.SEM_CONEXAO,
                        solarL: element.solar !== undefined ? element.solar : this.props.res.SEM_CONEXAO,
                        addressStationL: element.addressStation !== undefined ? element.addressStation : this.props.res.SEM_CONEXAO,
                        delta_tL: deltaTValue !== undefined ? deltaTValue : this.props.res.SEM_CONEXAO,
                        nameL: element.name !== -99 && element.name !== null ? element.name : this.props.res.SEM_CONEXAO,
                        heightL: (typeof element.height === 'number' && element.height !== -99 && element.height !== null && !isNaN(element.height)) ? element.height.toFixed(1) : this.props.res.SEM_CONEXAO,
                        datetimeL: element.datetime !== -99 && element.datetime !== null ? Moment(element.datetime).format(this.props.res.FORMAT_DATAHORAMIN) : this.props.res.SEM_CONEXAO,
                        humidityL: (typeof element.humidity === 'number' && element.humidity !== -99 && element.humidity !== null && !isNaN(element.humidity)) ? (element.humidity > 100 ? 100 : element.humidity.toFixed(1)) : this.props.res.SEM_CONEXAO,
                        air_humidityL: element.air_humidity !== -99 && element.air_humidity !== null ? (element.air_humidity > 100 ? 100 : element.air_humidity) : this.props.res.SEM_CONEXAO,
                        temperatureL: (typeof element.temperature === 'number' && element.temperature !== -99 && element.temperature !== null && !isNaN(element.temperature)) ? element.temperature.toFixed(1) : this.props.res.SEM_CONEXAO,
                        air_temperatureL: element.air_temperature !== -99 && element.air_temperature !== null ? element.air_temperature : this.props.res.SEM_CONEXAO,
                        wind_directionL: (typeof element.wind_direction === 'number' && element.wind_direction !== -99 && element.wind_direction !== null && !isNaN(element.wind_direction)) ? element.wind_direction.toFixed(1) : this.props.res.SEM_CONEXAO,
                        pressureL: (typeof element.pressure === 'number' && element.pressure !== -99 && element.pressure !== null && !isNaN(element.pressure)) ? element.pressure.toFixed(1) : this.props.res.SEM_CONEXAO,
                        wind_speedL: (typeof element.wind_speed === 'number' && element.wind_speed !== -99 && element.wind_speed !== null && !isNaN(element.wind_speed)) ? element.wind_speed : this.props.res.SEM_CONEXAO,
                    };

                    this.setState(newState);
                    this.tempMarker = element;
                    break;
                }
            }
        } else {
            this.tempMarker = null;
        }
    };

    handleListItemClick = (id) => {
        const { stationData } = this.state;

        this.setState({ idStationSelected: id }, () => {
            const { idStationSelected } = this.state;

            let poly;
            let idStation;
            let lat;
            let lng;

            const selectedStation = stationData.find((item) => item.id_source === idStationSelected);

            if (selectedStation) {
                poly = this.mymap._layers[selectedStation.id];
                idStation = selectedStation.id_source;
                lat = selectedStation.lat;
                lng = parseFloat(selectedStation.lng);
                this.setState({ stationName: selectedStation.name });

                const hourSlider = Moment(selectedStation.datetime).format("HH");
                this.setState({ selectedTime: hourSlider.replace(/^0+/, '') });
            }

            this.handleClickP(poly, idStation);

            if (lat && lng) {
                this.mymap.setView([lat, lng], 14);
            }

            this.clearFilters();

            this.handleFilterDate();
        });
    };

    handleDateChange = (e) => {
        this.setState({ selectedDate: e.target.value, filterStations: [], isLoading: true, selectedTime: '' });
    };

    handleMonthChange = (e) => {
        this.setState({ selectedMonth: e.target.value, monthlyData: [], isLoading: true });
    };

    handleYearChange = (e) => {
        this.setState({ selectedYear: e.target.value, yearlyData: [], isLoading: true });
    };

    handleWeekChange = (event) => {
        const selectedWeekStart = new Date(event.target.value);
        const today = new Date();
        const potentialEndDate = new Date(selectedWeekStart);
        potentialEndDate.setDate(selectedWeekStart.getDate() + 6);
        const selectedWeekEnd = potentialEndDate > today ? today : potentialEndDate;

        this.setState({
            selectedWeekStart: selectedWeekStart.toISOString().split('T')[0],
            selectedWeekEnd: selectedWeekEnd.toISOString().split('T')[0],
            isLoading: true
        });
    };

    handleFilterDate = () => {
        const { selectedDate, stationData, stations, idStationSelected } = this.state;
        const { res } = this.props;

        let stationId;
        let lat;
        let lng;
        const stationFilter = stations.filter(station => station.id == idStationSelected);

        stationFilter.forEach((item) => {
            stationId = item.id;
        });

        const findStation = stationData.filter((station) => station.id_source == stationId);

        if (findStation.length > 0) {
            lat = parseFloat(findStation[0]?.lat);
            lng = parseFloat(findStation[0]?.lng);
        }

        if (lat && lng) {
            this.mymap.setView([lat, lng]);
        }

        const today = this.getLocalDate()
        if (selectedDate !== today) {
            this.stopAutoUpdate();
            this.setState({ autoUpdate: false });
        }

        if (findStation.length > 0) {
            const station = findStation[0];

            this.list_stations_data(stationId, selectedDate);

            if (!station.delta_t) {
                this.setState({ flightConditions: res.SEM_CONEXAO });
            } else if (station.delta_t.toFixed(1) >= 2 && station.delta_t.toFixed(1) <= 8) {
                this.setState({ flightConditions: res.CONDICOES_ADEQUADAS });
            } else if (station.delta_t.toFixed(1) > 10) {
                this.setState({ flightConditions: res.CONDICOES_INADEQUADAS });
            } else {
                this.setState({ flightConditions: res.CONDICOES_ARRISCADAS });
            }
            this.setState({
                selectedInfo: 'weatherChart',
                datetimeL: Moment(station.datetime).format(res.FORMAT_DATAHORAMIN),
                humidityL: station.humidity !== null ? station.humidity : '',
                air_humidityL: station.air_humidity !== null ? station.air_humidity : '',
                temperatureL: station.temperature !== null ? station.temperature : '',
                air_temperatureL: station.air_temperature !== null ? station.air_temperature : '',
                heightL: station.height !== null ? station.height : '',
                pressureL: station.pressure !== null ? station.pressure : '',
                wind_speedL: station.wind_speed !== null ? station.wind_speed : '',
                wind_directionL: station.wind_direction !== null ? station.wind_direction : '',
                delta_tL: station.delta_t !== null ? station.delta_t.toFixed(1) : '',
                thermalInversionL: !station.temperature ? res.DESABILITADO
                    : Number(station.air_temperature) - (Number(station.temperature) + 3) > 0
                        ? res.GRANDES_INVERSÃO_TERMICA
                        : Number(station.air_temperature) - (Number(station.temperature) + 1) > 0
                            ? res.PODE_ESTAR_INVERSÃO_TERMICA
                            : res.NAO_INVERSÃO_TERMICA,
                solarL: station.solar !== null ? station.solar.toFixed(1) : '',
                rainL: station.rain !== null ? station.rain : '',
                selectedTime: ''
            });
        } else {
            this.setState({
                datetimeL: '',
                humidityL: '',
                air_humidityL: '',
                temperatureL: '',
                air_temperatureL: '',
                heightL: '',
                pressureL: '',
                wind_speedL: '',
                wind_directionL: '',
                delta_tL: '',
                thermalInversionL: '',
                solarL: '',
                rainL: '',
                selectedTime: ''
            });
        }
    };

    generateChart() {
        const { res } = this.props;
        const { selectedInfo, filterStations, windSpeedUnit } = this.state;
        this.setCurrentChart('generateChart');
        let modulesLabel = '';
        let labels = filterStations.map((station) => Moment(station.datetime).format("HH:mm"));

        if (selectedInfo === 'weatherChart') {
            const temperatureData = filterStations
                .filter(module => module.air_temperature !== -99)
                .map(module => (res.LINGUA === 'en-US' ? tools.round(tools.c_to_f(module.air_temperature), 1) : tools.round(module.air_temperature, 1)));

            const filteredTemperatureData = temperatureData.filter(temp => temp !== 0 && temp !== undefined);
            const maxTemperature = Math.max(...filteredTemperatureData);
            const minTemperature = Math.min(...filteredTemperatureData);

            const temperatureDataset = {
                label: tools.replaceString(res._TEMPERATURA_UNI, res.LINGUA === 'en-US' ? res.F : res.C),
                data: temperatureData,
                yAxisID: 'temperature',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const humidityData = filterStations
                .filter(module => module.air_humidity !== -99)
                .map(module => {
                    let humidity = module.air_humidity?.toFixed(1);
                    return humidity > 100 ? 100 : humidity;
                });

            const filteredHumidityData = humidityData.filter(humidity => humidity !== 0 && humidity !== undefined);
            let maxHumidity, minHumidity;

            if (filteredHumidityData.length > 0) {
                maxHumidity = Math.max(...filteredHumidityData);
                minHumidity = Math.min(...filteredHumidityData);
            } else {
                maxHumidity = minHumidity = this.props.res.SEM_CONEXAO;
            }

            const humidityDataset = {
                label: res.HUMIDADE_UNI,
                data: humidityData,
                yAxisID: 'humidity',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            const preferredUnit = windSpeedUnit;

            const windSpeedData = filterStations
                .filter(module => module.wind_speed !== -99)
                .map(module => {
                    const speed = parseFloat(module.wind_speed?.toFixed(1));
                    return preferredUnit === 'km/h' ? parseFloat((speed * 3.6).toFixed(1)) : speed;
                });

            const filteredWindSpeedData = windSpeedData.filter(wind => wind !== 0 && wind !== undefined);
            const maxWindSpeed = Math.max(...filteredWindSpeedData);
            const minWindSpeed = Math.min(...filteredWindSpeedData);

            const windSpeedDataset = {
                label: `${res.VENTO_VELOCIDADE} (${preferredUnit})`,
                data: windSpeedData,
                yAxisID: 'windSpeed',
                backgroundColor: '#FFE7D0',
                borderColor: '#FFE7D0',
                borderWidth: 1
            };

            modulesLabel = `
                ${res.TEMPERATURA_}: ${isFinite(minTemperature) && isFinite(maxTemperature)
                    ? `${minTemperature.toFixed(1)}°C / ${maxTemperature.toFixed(1)}${res.LINGUA === 'en-US' ? res.F : res.C}`
                    : this.props.res.SEM_CONEXAO
                }
                ${res.UMIDADE_}: ${isFinite(minHumidity) && isFinite(maxHumidity)
                    ? `${minHumidity.toFixed(1)} % / ${maxHumidity.toFixed(1)} %`
                    : this.props.res.SEM_CONEXAO
                }
                ${res.VENTO_VELOCIDADE}: ${isFinite(minWindSpeed) && isFinite(maxWindSpeed)
                    ? `${minWindSpeed.toFixed(1)} ${preferredUnit} / ${maxWindSpeed.toFixed(1)} ${preferredUnit}`
                    : this.props.res.SEM_CONEXAO
                }
`;

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartModulesData');

            if (chartElement) {
                const ctx = chartElement.getContext('2d');

                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [temperatureDataset, humidityDataset, windSpeedDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            temperature: {
                                id: 'temperature',
                                type: 'linear',
                                title: {
                                    display: true,
                                    color: '#FA9F34',
                                    text: tools.replaceString(res._TEMPERATURA_UNI, res.C),
                                },
                                ticks: {
                                    color: 'lightgray',
                                },
                                display: true,
                                position: 'left',
                            },
                            humidity: {
                                id: 'humidity',
                                type: 'linear',
                                title: {
                                    display: true,
                                    color: '#FA3834',
                                    text: res.HUMIDADE_UNI,
                                },
                                ticks: {
                                    color: 'lightgray',
                                },
                                display: true,
                                position: 'right',
                            },
                            windSpeed: {
                                id: 'windSpeed',
                                type: 'linear',
                                title: {
                                    display: true,
                                    color: '#FFE7D0',
                                    text: `${res.VENTO_VELOCIDADE} (${preferredUnit === 'km/h' ? 'km/h' : 'm/s'})`,
                                },
                                ticks: {
                                    color: 'lightgray',
                                },
                                display: true,
                                position: 'right',
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'humidity') {
            const humidityData = filterStations
                .filter(module => module.humidity !== -99)
                .map(module => {
                    let humidity = module.humidity?.toFixed(1);
                    return humidity > 100 ? 100 : humidity;
                });

            const filteredHumidityData = humidityData.filter(humidity => humidity !== 0 && humidity !== undefined);
            const airHumidityData = filterStations
                .filter(module => module.air_humidity !== -99)
                .map(module => {
                    let air_humidity = module.air_humidity?.toFixed(1);
                    return air_humidity > 100 ? 100 : air_humidity;
                });

            const filteredAirHumidityData = airHumidityData.filter(air_humidity => air_humidity !== 0 && air_humidity !== undefined);

            let humidityDataset;
            let modulesLabel;
            let datasets = [];

            if (filteredHumidityData.length > 0 && filteredAirHumidityData.length > 0) {
                let maxHumidity = Math.max(...filteredHumidityData);
                let minHumidity = Math.min(...filteredHumidityData);
                let maxAirHumidity = Math.max(...filteredAirHumidityData);
                let minAirHumidity = Math.min(...filteredAirHumidityData);

                humidityDataset = {
                    label: res.UMIDADE_INFERIOR_,
                    data: humidityData,
                    yAxisID: 'humidity',
                    backgroundColor: '#FA9F34',
                    borderColor: '#FA9F34',
                    borderWidth: 1
                };

                const airHumidityDataset = {
                    label: res.UMIDADE_SUPERIOR_,
                    data: airHumidityData,
                    yAxisID: 'air_humidity',
                    backgroundColor: '#FA3834',
                    borderColor: '#FA3834',
                    borderWidth: 1
                };

                modulesLabel = `
                    ${res.UMIDADE_INFERIOR}: ${isFinite(minHumidity) && isFinite(maxHumidity)
                        ? `${minHumidity.toFixed(1)} % / ${maxHumidity.toFixed(1)} %`
                        : res.SEM_CONEXAO}
                    ${res.UMIDADE_SUPERIOR}: ${isFinite(minAirHumidity) && isFinite(maxAirHumidity)
                        ? `${minAirHumidity.toFixed(1)} % / ${maxAirHumidity.toFixed(1)} %`
                        : res.SEM_CONEXAO}
                `;

                datasets = [humidityDataset, airHumidityDataset];

            } else if (filteredHumidityData.length === 0 && filteredAirHumidityData.length > 0) {
                let maxAirHumidity = Math.max(...filteredAirHumidityData);
                let minAirHumidity = Math.min(...filteredAirHumidityData);

                humidityDataset = {
                    label: res.HUMIDADE_UNI,
                    data: airHumidityData,
                    yAxisID: 'humidity',
                    backgroundColor: '#FA9F34',
                    borderColor: '#FA9F34',
                    borderWidth: 1
                };

                modulesLabel = `
                    ${res.UMIDADE_}: ${isFinite(minAirHumidity) && isFinite(maxAirHumidity)
                        ? `${minAirHumidity.toFixed(1)} % / ${maxAirHumidity.toFixed(1)} %`
                        : 'Sem conexão'}
                `;

                datasets = [humidityDataset];
            }

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartHumidity');

            if (chartElement) {
                const ctx = chartElement.getContext('2d');

                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: datasets
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            humidity: {
                                id: 'humidity',
                                type: 'linear',
                                title: {
                                    display: true,
                                    color: '#FA9F34',
                                    text: datasets.length > 1 ? res.UMIDADE_INFERIOR_ : res.HUMIDADE_UNI,
                                },
                                ticks: {
                                    color: 'lightgray',
                                },
                                display: true,
                                position: 'left',
                                scaleLabel: {
                                    display: true,
                                    labelString: datasets.length > 1 ? res.UMIDADE_INFERIOR_ : res.HUMIDADE_UNI,
                                    color: 'white',
                                }
                            },
                            ...(datasets.length > 1 ? {
                                air_humidity: {
                                    id: 'air_humidity',
                                    type: 'linear',
                                    title: {
                                        display: true,
                                        color: '#FA3834',
                                        text: res.UMIDADE_INFERIOR_,
                                    },
                                    ticks: {
                                        color: 'lightgray',
                                    },
                                    display: true,
                                    position: 'right',
                                    scaleLabel: {
                                        display: true,
                                        labelString: res.UMIDADE_INFERIOR_,
                                        color: 'white',
                                    }
                                }
                            } : {}),
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'temperature') {
            const unidade = res.LINGUA === 'en-US' ? res.F : res.C;
            const temperatureData = filterStations
                .filter(module => module.temperature !== -99)
                .map(module => (res.LINGUA === 'en-US' ? tools.c_to_f(module.temperature).toFixed(1) : module.temperature?.toFixed(1)));
            const filteredTemperatureData = temperatureData.filter(temperature => temperature !== 0 && temperature !== undefined);

            const airTemperatureData = filterStations
                .filter(module => module.air_temperature !== -99)
                .map(module => (res.LINGUA === 'en-US' ? tools.c_to_f(module.air_temperature).toFixed(1) : module.air_temperature?.toFixed(1)));
            const filteredAirTemperatureData = airTemperatureData.filter(air_temperature => air_temperature !== 0 && air_temperature !== undefined);

            let temperatureDataset;
            let modulesLabel;
            let datasets = [];

            if (filteredTemperatureData.length > 0 && filteredAirTemperatureData.length > 0) {
                let maxTemperature = Math.max(...filteredTemperatureData);
                let minTemperature = Math.min(...filteredTemperatureData);
                let maxAirTemperature = Math.max(...filteredAirTemperatureData);
                let minAirTemperature = Math.min(...filteredAirTemperatureData);

                temperatureDataset = {
                    label: tools.replaceString(res._TEMPERATURA_INFERIOR_UNI, unidade),
                    data: temperatureData,
                    yAxisID: 'temperature',
                    backgroundColor: '#FA9F34',
                    borderColor: '#FA9F34',
                    borderWidth: 1
                };

                const airTemperatureDataset = {
                    label: tools.replaceString(res._TEMPERATURA_SUPERIOR_UNI, unidade),
                    data: airTemperatureData,
                    yAxisID: 'air_temperature',
                    backgroundColor: '#FA3834',
                    borderColor: '#FA3834',
                    borderWidth: 1
                };

                modulesLabel = `
                    ${res.TEMPERATURA_INFERIOR}: ${isFinite(minTemperature) && isFinite(maxTemperature)
                        ? `${minTemperature.toFixed(1)} % / ${maxTemperature.toFixed(1)} %`
                        : 'Sem conexão'}
                    ${res.TEMPERATURA_SUPERIOR}: ${isFinite(minAirTemperature) && isFinite(maxAirTemperature)
                        ? `${minAirTemperature.toFixed(1)} % / ${maxAirTemperature.toFixed(1)} %`
                        : res.SEM_CONEXAO}
                `;

                datasets = [temperatureDataset, airTemperatureDataset];

            } else if (filteredTemperatureData.length === 0 && filteredAirTemperatureData.length > 0) {
                let maxAirTemperature = Math.max(...filteredAirTemperatureData);
                let minAirTemperature = Math.min(...filteredAirTemperatureData);

                temperatureDataset = {
                    label: tools.replaceString(res._TEMPERATURA_UNI, unidade),
                    data: airTemperatureData,
                    yAxisID: 'temperature',
                    backgroundColor: '#FA9F34',
                    borderColor: '#FA9F34',
                    borderWidth: 1
                };

                modulesLabel = `
                    Temperatura: ${isFinite(minAirTemperature) && isFinite(maxAirTemperature)
                        ? `${minAirTemperature.toFixed(1)} % / ${maxAirTemperature.toFixed(1)} %`
                        : res.SEM_CONEXAO}
                `;

                datasets = [temperatureDataset];
            }

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartTemperature');

            if (chartElement) {
                const ctx = chartElement.getContext('2d');

                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: datasets,
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            temperature: {
                                id: 'temperature',
                                type: 'linear',
                                title: {
                                    display: true,
                                    color: '#FA9F34',
                                    text: datasets.length > 1 ? tools.replaceString(res._TEMPERATURA_INFERIOR_UNI, unidade) : tools.replaceString(res._TEMPERATURA_UNI, unidade),
                                },
                                ticks: {
                                    color: 'lightgray',
                                },
                                display: true,
                                position: 'left',
                                scaleLabel: {
                                    display: true,
                                    labelString: datasets.length > 1 ? tools.replaceString(res._TEMPERATURA_INFERIOR_UNI, unidade) : tools.replaceString(res._TEMPERATURA_UNI, unidade),
                                    color: 'white',
                                }
                            },
                            ...(datasets.length > 1 ? {
                                air_temperature: {
                                    id: 'air_temperature',
                                    type: 'linear',
                                    title: {
                                        display: true,
                                        color: '#FA3834',
                                        text: tools.replaceString(res._TEMPERATURA_SUPERIOR_UNI, unidade),
                                    },
                                    ticks: {
                                        color: 'lightgray',
                                    },
                                    display: true,
                                    position: 'right',
                                    scaleLabel: {
                                        display: true,
                                        labelString: tools.replaceString(res._TEMPERATURA_SUPERIOR_UNI, unidade),
                                        color: 'white',
                                    }
                                }
                            } : {}),
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'thermalInversion') {
            const thermalInversionData = filterStations.map((module) => {
                const thermalInversion1 = module.air_temperature - 1 > module.temperature;
                const thermalInversion5 = module.air_temperature - 5 > module.temperature;

                if (thermalInversion5) {
                    return { value: 3, color: '#FA9F34' };
                } else if (thermalInversion1) {
                    return { value: 2, color: '#FABA34' };
                } else {
                    return { value: 1, color: '#FAB288' };
                }
            });

            const generateLabel = (value) => {
                if (value === 1) {
                    return res.NAO_OCORRENDO_INVERSAO_TERMICA;
                } else if (value === 2) {
                    return res.PODE_ESTAR_INVERSÃO_TERMICA;
                } else if (value === 3) {
                    return res.GRANDES_INVERSÃO_TERMICA;
                }
            };

            const thermalInversionDataset = {
                label: res.INVERSAO_TERMICA,
                data: thermalInversionData.map(data => data.value),
                backgroundColor: thermalInversionData.map(data => data.color),
                borderColor: thermalInversionData.map(data => data.color),
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartThermalInversion');

            if (chartElement) {
                const ctx = chartElement.getContext('2d');

                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [thermalInversionDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: {
                                display: true,
                                labels: {
                                    color: 'white',
                                    generateLabels: function () {
                                        return [
                                            {
                                                text: res.NAO_OCORRENDO_INVERSAO_TERMICA,
                                                fillStyle: '#FAB288',
                                                lineWidth: 1,
                                            },
                                            {
                                                text: res.PODE_ESTAR_INVERSÃO_TERMICA,
                                                fillStyle: '#FABA34',
                                                lineWidth: 1,
                                            },
                                            {
                                                text: res.GRANDES_INVERSÃO_TERMICA,
                                                fillStyle: '#FA9F34',
                                                lineWidth: 1,
                                            }
                                        ];
                                    }
                                }
                            },
                            tooltip: {
                                callbacks: {
                                    label: function (context) {
                                        const value = context.dataset.data[context.dataIndex];
                                        return generateLabel(value);
                                    }
                                }
                            }
                        },
                        scales: {
                            y: {
                                min: 0,
                                max: 4,
                                ticks: {
                                    color: 'lightgray',
                                    stepSize: 1,
                                    callback: function (val) {
                                        return val === 3 ? res.GRANDES_INVERSÃO_TERMICA :
                                            val === 2 ? res.PODE_ESTAR_INVERSÃO_TERMICA :
                                                val === 1 ? res.NAO_OCORRENDO_INVERSAO_TERMICA : null;
                                    }
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        }
                    }
                });
            }
        } else if (selectedInfo === 'rain') {
            const unidade = res.LINGUA === 'en-US' ? res.IN : res.MM;
            const rainData = filterStations.map((module) => {
                const rainValue = module.rain;
                return rainValue === -99 || rainValue === undefined ? 0 : rainValue;
            });
            const validData = rainData.filter(value => value > 0);
            const maxVal = Math.max(...validData);
            const minVal = Math.min(...validData);
            const rainTotal = validData.reduce((sum, value) => sum + value, 0);

            const formatMinMaxLabel = (min, max, total) => {
                if (isFinite(min) && isFinite(max)) {
                    return `Total de chuva diário: ${max.toFixed(1)} ${unidade}`;
                } else {
                    return `Total de chuva diário: Sem dados válidos`;
                }
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartRain');

            if (chartElement) {
                const ctx = chartElement.getContext('2d');

                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: `${res.CHUVA} (mm)`,
                            data: rainData,
                            backgroundColor: '#FA9F34',
                            borderColor: '#FA9F34',
                            borderWidth: 1,
                            pointBackgroundColor: rainData.map(value => value === 0 ? '#FAB288' : '#FA9F34'),
                            pointBorderColor: rainData.map(value => value === 0 ? '#FAB288' : '#FA9F34'),
                            fill: false,
                        }],
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    color: 'white',
                                },
                                title: {
                                    display: true,
                                    text: `${res.CHUVA} (mm)`,
                                    color: 'white',
                                },
                            },
                            x: {
                                ticks: {
                                    color: 'white',
                                },
                            },
                        },
                        plugins: {
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                            tooltip: {
                                mode: 'index',
                                intersect: false,
                            },
                            title: {
                                display: true,
                                text: formatMinMaxLabel(minVal, maxVal, rainTotal),
                                color: 'white',
                                position: 'bottom',
                            },
                        },
                        elements: {
                            line: {
                                tension: 0.1
                            },
                            point: {
                                radius: 3
                            }
                        },
                    },
                });
            }
        } else if (selectedInfo === 'solar') {
            let startTime = '-';
            let endTime = '-';
            let firstSolarValue = false;
            const solarValues = [];

            filterStations.forEach((module) => {
                const solarValue = module.solar;
                const time = Moment(module.datetime).format("HH:mm");
                let color, value;
                if (solarValue === -99 || solarValue < 3) {
                    color = '#FAB288';
                    value = 1;
                } else if (solarValue >= 3 && solarValue <= 400) {
                    if (!firstSolarValue) {
                        startTime = time;
                        firstSolarValue = true;
                    }
                    endTime = time;

                    color = '#FABA34';
                    value = 2;
                } else if (solarValue >= 401 && solarValue <= 800) {
                    color = '#FA9F34';
                    value = 3;
                } else if (solarValue > 801) {
                    color = '#FA3834';
                    value = 4;
                }

                solarValues.push({ value, color });
            });

            const solarDataset = {
                label: `Nível de ${res.RADIACAO_SOLAR}`,
                data: solarValues.map(item => item.value),
                backgroundColor: solarValues.map(item => item.color),
                borderColor: solarValues.map(item => item.color),
                borderWidth: 1
            };
            const formatMinMaxLabel = (startTime, endTime) => {
                if (startTime && endTime) {
                    return `Início da radiação solar: ${startTime} / Término da radiação solar: ${endTime}`;
                } else {
                    return `Sem dados válidos`;
                }
            };
            const generateLabel = (value) => {
                if (value === 1) {
                    return 'Sem radiação solar';
                } else if (value === 2) {
                    return 'Radiação solar baixa';
                } else if (value === 3) {
                    return 'Radiação solar moderada';
                } else if (value === 4) {
                    return 'Radiação solar alta';
                }
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartSolar');

            if (chartElement) {
                const ctx = chartElement.getContext('2d');

                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [solarDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: {
                                display: true,
                                labels: {
                                    color: 'white',
                                    generateLabels: function () {
                                        return [
                                            {
                                                text: 'Sem radiação solar',
                                                fillStyle: '#FAB288',
                                                lineWidth: 1,
                                            },
                                            {
                                                text: 'Radiação solar baixa',
                                                fillStyle: '#FABA34',
                                                lineWidth: 1,
                                            },
                                            {
                                                text: 'Radiação solar moderada',
                                                fillStyle: '#FA9F34',
                                                lineWidth: 1,
                                            },
                                            {
                                                text: 'Radiação solar alta',
                                                fillStyle: '#FA3834',
                                                lineWidth: 1,
                                            }
                                        ];
                                    }
                                }
                            },
                            tooltip: {
                                callbacks: {
                                    label: function (context) {
                                        const value = context.dataset.data[context.dataIndex];
                                        return generateLabel(value);
                                    }
                                }
                            },
                            title: {
                                display: true,
                                text: formatMinMaxLabel(startTime, endTime),
                                color: 'white',
                                position: 'bottom',
                            },
                        },
                        scales: {
                            y: {
                                min: 1,
                                max: 5,
                                ticks: {
                                    color: 'lightgray',
                                    stepSize: 1,
                                    callback: function (val, index) {
                                        switch (val) {
                                            case 4:
                                                return 'Radiação solar alta';
                                            case 3:
                                                return 'Radiação solar moderada';
                                            case 2:
                                                return 'Radiação solar baixa';
                                            case 1:
                                                return 'Sem radiação solar';
                                            default:
                                                return null;
                                        }
                                    }
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        }
                    }
                });
            }
        } else {
            const modulesData = filterStations
                .filter(module => module[selectedInfo] !== -99 && module[selectedInfo] !== undefined && module[selectedInfo] !== null)
                .map(module => {
                    if (selectedInfo === 'wind_speed') {
                        const speed = parseFloat(module[selectedInfo].toFixed(1));
                        return this.state.windSpeedUnit === 'km/h' ? parseFloat((speed * 3.6).toFixed(1)) : speed;
                    }
                    return parseFloat(module[selectedInfo].toFixed(1));
                });

            const windDirections = filterStations
                .filter(module => module[selectedInfo] !== -99 && module[selectedInfo] !== undefined && module[selectedInfo] !== null)
                .map(module => module['wind_direction'] ?? 0);

            const filteredModulesData = modulesData.filter(value => value !== 0 && value !== '0.0');
            const maxVal = Math.max(...filteredModulesData);
            const minVal = Math.min(...filteredModulesData);

            const formatLabel = (label, min, max, unit) => {
                return isFinite(min) && isFinite(max)
                    ? `${label}: ${min.toFixed(1)} ${unit} / ${max.toFixed(1)} ${unit}`
                    : `${label}: Sem conexão`;
            };

            let unit;
            if (selectedInfo === 'pressure') {
                unit = 'hPa';
                modulesLabel = formatLabel(res.PRESSAO, minVal, maxVal, unit);
            } else if (selectedInfo === 'height') {
                unit = 'm';
                modulesLabel = formatLabel(res.ALTITUDE, minVal, maxVal, unit);
            } else if (selectedInfo === 'wind_direction') {
                unit = '°';
                modulesLabel = formatLabel(res.DIRECAO_VENTO, minVal, maxVal, unit);
            } else if (selectedInfo === 'wind_speed') {
                unit = this.state.windSpeedUnit;
                modulesLabel = formatLabel(res.VENTO_VELOCIDADE, minVal, maxVal, unit);
            } else if (selectedInfo === 'delta_t') {
                unit = '';
                modulesLabel = formatLabel(res.DELTA_T, minVal, maxVal, unit);
            }

            let valueLabel = '';
            if (selectedInfo === 'pressure') valueLabel = `${res.PRESSAO} (${res.HECTOPASCAL})`;
            else if (selectedInfo === 'height') valueLabel = `${res.ALTITUDE} (${res.METROS})`;
            else if (selectedInfo === 'wind_direction') valueLabel = `${res.DIRECAO_VENTO} (${res.GRAUS})`;
            else if (selectedInfo === 'wind_speed') valueLabel = `${res.VENTO_VELOCIDADE} (${this.state.windSpeedUnit})`;
            else if (selectedInfo === 'delta_t') valueLabel = `${res.DELTA_T}`;

            if (this.barChart) this.barChart.destroy();

            const chartElement = document.getElementById('chartModules');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');

                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [{
                            label: valueLabel,
                            data: modulesData,
                            backgroundColor: '#FA9F34',
                            borderColor: '#FA9F34',
                            borderWidth: 1,
                            fill: false,
                            pointRadius: selectedInfo === 'wind_direction' || selectedInfo === 'wind_speed' ? 5 : 3,
                            pointBackgroundColor: selectedInfo === 'wind_direction' || selectedInfo === 'wind_speed' ? 'rgba(0,0,0,0)' : '#FA9F34',
                            pointBorderWidth: 0,
                            pointHoverRadius: selectedInfo === 'wind_direction' || selectedInfo === 'wind_speed' ? 6 : 4,
                            pointHoverBackgroundColor: selectedInfo === 'wind_direction' || selectedInfo === 'wind_speed' ? 'rgba(0,0,0,0)' : '#FA9F34',
                            showLine: true,
                        }],
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                ticks: { color: 'white' },
                                title: {
                                    display: true,
                                    text: valueLabel,
                                    color: '#FA9F34',
                                },
                            },
                            x: {
                                ticks: { color: 'white' },
                            },
                        },
                        plugins: {
                            legend: {
                                labels: { color: 'white' }
                            },
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            tooltip: {
                                enabled: false,
                                external: (context) => {
                                    const tooltipModel = context.tooltip;
                                    let tooltipEl = document.getElementById('chartjs-tooltip');
                                    if (!tooltipEl) {
                                        tooltipEl = document.createElement('div');
                                        tooltipEl.id = 'chartjs-tooltip';
                                        tooltipEl.style.position = 'absolute';
                                        tooltipEl.style.pointerEvents = 'none';
                                        tooltipEl.style.zIndex = '1000';
                                        document.body.appendChild(tooltipEl);
                                    }

                                    if (tooltipModel.opacity === 0) {
                                        tooltipEl.style.opacity = 0;
                                        return;
                                    }

                                    const dataPoint = tooltipModel.dataPoints?.[0];
                                    if (!dataPoint) return;

                                    const index = dataPoint.dataIndex;
                                    const value = modulesData[index];
                                    const hora = labels[index];

                                    let tooltipHTML = `<div><strong>${hora}</strong></div>`;

                                    if (selectedInfo === 'wind_speed') {
                                        tooltipHTML += `<div>Velocidade: ${value} ${this.state.windSpeedUnit}</div><div>Direção: ${windDirections[index]}°</div>`;
                                    } else if (selectedInfo === 'wind_direction') {
                                        tooltipHTML += `<div>Direção do Vento: ${value}°</div>`;
                                    } else {
                                        tooltipHTML += `<div>${valueLabel}: ${value}${unit ? ' ' + unit : ''}</div>`;
                                    }

                                    if (selectedInfo === 'wind_direction' || selectedInfo === 'wind_speed') {
                                        const angle = (selectedInfo === 'wind_speed' ? windDirections[index] : value) % 360;
                                        tooltipHTML += `
                                            <div style="display: flex; justify-content: center; align-items: center; margin-top: 4px;">
                                                <svg style="width: 24px; height: 24px; transform: rotate(${angle}deg); fill: #FA9F34;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                    <path d="M12 2L6 21l6-4 6 4-6-19z"/>
                                                </svg>
                                            </div>`;
                                    }

                                    tooltipEl.innerHTML = `
                                        <div style="background: rgba(0, 0, 0, 0.7); color: white; padding: 8px; border-radius: 4px;">
                                            ${tooltipHTML}
                                        </div>`;

                                    const position = context.chart.canvas.getBoundingClientRect();
                                    tooltipEl.style.opacity = 1;
                                    tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                                    tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                                }
                            },
                            arrowRenderer: {
                                drawArrows: selectedInfo === 'wind_direction' || selectedInfo === 'wind_speed',
                                data: selectedInfo === 'wind_speed' ? windDirections : modulesData
                            }
                        },
                        animation: false,
                    },
                    plugins: [{
                        id: 'arrowRenderer',
                        afterDatasetsDraw(chart, args, pluginOptions) {
                            if (!pluginOptions.drawArrows) return;

                            const { ctx } = chart;
                            const meta = chart.getDatasetMeta(0);

                            meta.data.forEach((point, index) => {
                                const value = pluginOptions.data[index];
                                const angle = value % 360;

                                ctx.save();
                                ctx.translate(point.x, point.y);
                                ctx.rotate((angle * Math.PI) / 180);
                                ctx.beginPath();
                                ctx.moveTo(0, -6);
                                ctx.lineTo(-4, 6);
                                ctx.lineTo(0, 3);
                                ctx.lineTo(4, 6);
                                ctx.closePath();
                                ctx.fillStyle = '#FA9F34';
                                ctx.fill();
                                ctx.restore();
                            });
                        }
                    }]
                });
            }
        }
    }

    list_stations_data = async (stationId, date) => {
        const { refreshInterval } = this.state;
        const dayStart = new Date(`${date}T00:00:00`).getTime() / 1000;
        const dayEnd = new Date(`${date}T23:59:59`).getTime() / 1000;

        const apiUrl = `${Config.server}/weather_data/daily/${refreshInterval}/${stationId}/${Math.floor(dayStart)}/${Math.floor(dayEnd)}`;
        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        try {
            const res = await fetch(apiUrl, options);

            const result = await res.json();

            if (result.length > 0) {
                const sortedByDate = result.sort((a, b) => new Date(a.datetime) - new Date(b.datetime));

                const addressStation = sortedByDate[0]?.addressStation;
                const hasRain = addressStation === 255 || addressStation === 200;
                const hasSolar = addressStation === 255;


                this.setState({
                    filterStations: sortedByDate,
                    sliderData: result,
                    hasRain,
                    hasSolar,
                    noData: false,
                    isLoading: false
                }, () => {
                    this.generateChart();
                });
            } else {
                this.setState({ noData: true });
                notification.open({
                    message: this.props.res.ATENCAO,
                    description: this.props.res.ERRO_ESTACAO,
                    icon: <MaterialIcon icon="error" className="text-danger" />
                });
            }
        } catch (error) {
            this.setState({ isLoading: false });
            if (error.status === 405) {
                notification.open({
                    message: this.props.res.PERMISSAO,
                    description: this.props.res.PERMISSAO_MSG,
                    icon: <MaterialIcon icon="error" className="text-danger" />
                });
            } else if (error.status === 401 || error.status === 403) {
                this.props.link('/login');
            } else {
                notification.open({
                    message: this.props.res.ERRO,
                    description: this.props.res.ERRO_MSG,
                    icon: <MaterialIcon icon="error" className="text-danger" />
                });
            }
        }
    };

    updateModalField = (modulesName, value) => {
        this.setState({ [modulesName]: value });
    };

    getDataById = (sourceID, stationName) => {
        const apiUrl = Config.server + `/weather_data/${sourceID}`;
        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then((result) => {
                if (result.length > 0) {
                    const { stationData, idStationSelected } = this.state;
                    const { res } = this.props;

                    const element = result[result.length - 1];
                    const wind = element.wind_speed * 3.6;
                    const tempMark = new WeatherData();
                    tempMark.name = stationName;
                    tempMark.id = element.id;
                    tempMark.id_company = element.id_company;
                    tempMark.id_source = element.id_source;
                    tempMark.lat = element.latAverage;
                    tempMark.lng = element.lngAverage;
                    tempMark.height = (typeof element.height === 'number' && !isNaN(element.height)) ? element.height.toFixed(1) : res.SEM_CONEXAO;
                    tempMark.datetime = element.datetime;
                    tempMark.pressure = (typeof element.pressure === 'number' && !isNaN(element.pressure)) ? element.pressure.toFixed(1) : res.SEM_CONEXAO;
                    tempMark.humidity = (typeof element.humidity === 'number' && !isNaN(element.humidity)) ? element.humidity.toFixed(1) : res.SEM_CONEXAO;
                    tempMark.air_humidity = (typeof element.air_humidity === 'number' && !isNaN(element.air_humidity)) ? element.air_humidity.toFixed(1) : res.SEM_CONEXAO;
                    tempMark.temperature = (typeof element.temperature === 'number' && !isNaN(element.temperature)) ? element.temperature.toFixed(1) : res.SEM_CONEXAO;
                    tempMark.air_temperature = (typeof element.air_temperature === 'number' && !isNaN(element.air_temperature)) ? element.air_temperature.toFixed(1) : res.SEM_CONEXAO;
                    tempMark.wind_direction = (typeof element.wind_direction === 'number' && !isNaN(element.wind_direction)) ? element.wind_direction.toFixed(1) : res.SEM_CONEXAO;

                    const preferredUnit = localStorage.getItem('windSpeedUnit') || 'km/h';
                    tempMark.wind_speed = preferredUnit === 'km/h' ? (wind && typeof wind === 'number' ? wind.toFixed(1) : res.SEM_CONEXAO) : (element.wind_speed && typeof element.wind_speed === 'number' ? element.wind_speed.toFixed(1) : res.SEM_CONEXAO);

                    tempMark.delta_t = element.delta_t;
                    tempMark.data_plus = element.data_plus;
                    tempMark.rain = element.rain;
                    tempMark.solar = element.solar;
                    tempMark.addressStation = element.addressStation;

                    let iconStation;
                    const lastDataTime = Moment(tempMark.datetime);
                    const currentTime = Moment();
                    const diffInMinutes = currentTime.diff(lastDataTime, 'minutes');

                    if (diffInMinutes >= 0 && diffInMinutes <= 20) {
                        iconStation = 22;
                        tempMark.zIndex = 1000;
                    } else {
                        iconStation = 23;
                        tempMark.zIndex = 500;
                    }

                    tempMark.img = img[Number(iconStation)].img;

                    this.drawMarker(tempMark);
                    const existingDataIndex = stationData.findIndex(sd => sd.id_source === tempMark.id_source);
                    if (existingDataIndex !== -1) {
                        stationData[existingDataIndex] = tempMark;
                    } else {
                        stationData.push(tempMark);
                    }
                    if (idStationSelected === sourceID) {
                        const datetimeData = result.map((item) => Moment(item.datetime).format("HH").replace(/^0+/, ''));
                        this.setState({ selectedTime: datetimeData[0] });

                        const item = tempMark;
                        const deltaT = item.delta_t?.toFixed(1);
                        const deltaTValue = deltaT != -99 && deltaT !== undefined && deltaT !== null ? deltaT : 'Sem conexão';

                        if (deltaTValue === false) {
                            this.setState({ flightConditions: res.SEM_CONEXAO });
                        } else if (deltaTValue >= 2 && deltaTValue <= 8) {
                            this.setState({ flightConditions: res.CONDICOES_ADEQUADAS });
                        } else if (deltaTValue > 10) {
                            this.setState({ flightConditions: res.CONDICOES_INADEQUADAS });
                        } else {
                            this.setState({ flightConditions: res.CONDICOES_ARRISCADAS });
                        }

                        this.updateModalField('latL', { error: false, input: geo.toDMS(item.lat, res.LATITUDE, 1), value: item.lat });
                        this.updateModalField('lngL', { error: false, input: geo.toDMS(item.lng, res.LONGITUDE, 1), value: item.lng });
                        this.updateModalField('nameL', item.name !== -99 && item.name != null ? item.name : res.SEM_CONEXAO);
                        this.updateModalField('heightL', item.height !== -99 && item.height != null ? item.height : res.SEM_CONEXAO);
                        this.updateModalField('datetimeL', item.datetime !== -99 && item.datetime != null ? Moment(item.datetime).format(res.FORMAT_DATAHORAMIN) : res.SEM_CONEXAO);
                        this.updateModalField('humidityL', item.humidity !== -99 && item.humidity != null ? (item.humidity > 100 ? 100 : item.humidity) : res.SEM_CONEXAO);
                        this.updateModalField('air_humidityL', item.air_humidity !== -99 && item.air_humidity != null ? (item.air_humidity > 100 ? 100 : item.air_humidity) : res.SEM_CONEXAO);
                        this.updateModalField('temperatureL', item.temperature !== -99 && item.temperature != null ? item.temperature : res.SEM_CONEXAO);
                        this.updateModalField('air_temperatureL', item.air_temperature !== -99 && item.air_temperature != null ? item.air_temperature : res.SEM_CONEXAO);
                        this.updateModalField('wind_directionL', item.wind_direction !== -99 && item.wind_direction != null ? item.wind_direction : res.SEM_CONEXAO);
                        this.updateModalField('pressureL', item.pressure !== -99 && item.pressure != null ? item.pressure : res.SEM_CONEXAO);
                        this.updateModalField('wind_speedL', item.wind_speed !== -99 && item.wind_speed != null ? item.wind_speed : res.SEM_CONEXAO);
                        this.updateModalField('delta_tL', deltaTValue);
                        this.updateModalField('thermalInversionL', !element.temperature ? res.DESABILITADO
                            : Number(element.air_temperature) - (Number(element.temperature) + 3) > 0
                                ? res.GRANDES_INVERSÃO_TERMICA
                                : Number(element.air_temperature) - (Number(element.temperature) + 1) > 0
                                    ? res.PODE_ESTAR_INVERSÃO_TERMICA
                                    : res.NAO_INVERSÃO_TERMICA);
                        this.updateModalField('addressStationL', item.addressStation !== -99 && item.addressStation != null ? item.addressStation : res.SEM_CONEXAO);
                        this.updateModalField('rainL', item.rain !== -99 && item.rain != null ? item.rain : res.SEM_CONEXAO);
                        this.updateModalField('solarL', item.solar !== -99 && item.solar != null ? item.solar : res.SEM_CONEXAO);
                    }
                    this.setState({ stationData });

                    setTimeout(() => {
                        this.setState({ loading: false });
                    }, 1000);
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                if (error.status === 405) {
                    notification.open({
                        message: this.props.res.PERMISSAO,
                        description: this.props.res.PERMISSAO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                } else {
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                }
            });
    };

    showChart = () => {
        const { selectedInfo, filterStations, noData, monthlyData, yearlyData, weeklyData, isLoading } = this.state;

        if (isLoading) {
            return (
                <Skeleton
                    variant="text"
                    style={{ margin: '0 0.5rem', transform: 'scale(1, 0.75)' }}
                    height={256}
                />
            );
        }

        if (noData === true) {
            return (
                <h3 className="noModulesTitle" >{this.props.res.ERRO_ESTACAO}</h3>
            );
        } else {
            if (filterStations.length > 0) {
                if (selectedInfo.length === 0) {
                    return (
                        <h3 className="noModulesTitle" >{this.props.res.SELECIONAR_MODULO}</h3>
                    );
                } else {
                    if (selectedInfo === 'weatherChart') {
                        return (
                            <canvas style={{ height: '240px' }} id="chartModulesData" ref={this.chartRef}></canvas>
                        );
                    } else if (selectedInfo === 'humidity') {
                        return (
                            <canvas style={{ height: '240px' }} id="chartHumidity" ref={this.chartRef}></canvas>
                        );
                    } else if (selectedInfo === 'temperature') {
                        return (
                            <canvas style={{ height: '240px' }} id="chartTemperature" ref={this.chartRef}></canvas>
                        );
                    } else if (selectedInfo === 'thermalInversion') {
                        return (
                            <canvas style={{ height: '240px' }} id="chartThermalInversion" ref={this.chartRef}></canvas>
                        );
                    } else if (selectedInfo === 'rain') {
                        return (
                            <canvas style={{ height: '240px' }} id="chartRain" ref={this.chartRef}></canvas>
                        );
                    } else if (selectedInfo === 'solar') {
                        return (
                            <canvas style={{ height: '240px' }} id="chartSolar" ref={this.chartRef}></canvas>
                        );
                    } else {
                        return (
                            <canvas style={{ height: '240px' }} id="chartModules" ref={this.chartRef}></canvas>
                        );
                    }
                }
            } else if (monthlyData.length > 0) {
                if (selectedInfo === 'temperatureMonth') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartTemperatureMonth" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'humidityMonth') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartHumidityMonth" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'pressureMonth') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartPressureMonth" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'windSpeedMonth') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartWindSpeedMonth" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'rainMonth') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartRainMonth" ref={this.chartRef}></canvas>
                    );
                }
            } else if (yearlyData.length > 0) {
                if (selectedInfo === 'temperatureYear') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartTemperatureYear" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'humidityYear') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartHumidityYear" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'pressureYear') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartPressureYear" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'windSpeedYear') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartWindSpeedYear" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'rainYear') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartRainYear" ref={this.chartRef}></canvas>
                    );
                }
            } else if (weeklyData.length > 0) {
                if (selectedInfo === 'temperatureWeek') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartTemperatureWeek" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'humidityWeek') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartHumidityWeek" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'pressureWeek') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartPressureWeek" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'windSpeedWeek') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartWindSpeedWeek" ref={this.chartRef}></canvas>
                    );
                } else if (selectedInfo === 'rainWeek') {
                    return (
                        <canvas style={{ height: '240px' }} id="chartRainWeek" ref={this.chartRef}></canvas>
                    );
                }
            }
        }
    };

    clearFilters = () => {
        const today = new Date();
        const currentMonth = (today.getMonth() + 1).toString().padStart(2, '0');
        const currentYear = today.getFullYear();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);

        this.setState({
            selectedDate: this.getLocalDate(),
            selectedMonth: `${currentYear}-${currentMonth}`,
            selectedYear: currentYear.toString(),
            selectedWeekStart: sevenDaysAgo.toISOString().split('T')[0],
            selectedWeekEnd: today.toISOString().split('T')[0],
            filterStations: [],
            filterStationData: [],
            selectedInfo: '',
        });
    };

    weatherForecast = () => {
        const { longitudeForecast, latitudeForecast } = this.state;

        // LINK API GRATUITA PREVISÃO DO  TEMPO
        // https://openweathermap.org

        const apiToken = 'af8af1343d4086f5a2132b0185e347c7';

        const apiUrl = `https://api.openweathermap.org/data/2.5/forecast?lat=${latitudeForecast.value}&lon=${longitudeForecast.value}&appid=${apiToken}&units=metric&lang=pt_br`;

        const options = {
            method: 'GET',
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    if (result) {
                        const daysData = [];
                        result.list.forEach((item) => {
                            const date = Moment.utc(item.dt_txt).local().format("YYYY-MM-DD");
                            const existingDay = daysData.find((day) => day.date === date);
                            if (!existingDay) {
                                daysData.push({
                                    id: Moment.utc(item.dt_txt).local().format("D"),
                                    date: date,
                                    minTemp: item.main.temp,
                                    maxTemp: item.main.temp,
                                    climateConditions: item.weather[0].main,
                                    description: item.weather[0].description,
                                    weatherData: [item],
                                });
                            } else {
                                if (item.main.temp < existingDay.minTemp) {
                                    existingDay.minTemp = item.main.temp;
                                }
                                if (item.main.temp > existingDay.maxTemp) {
                                    existingDay.maxTemp = item.main.temp;
                                }
                                existingDay.weatherData.push(item);
                            }
                        });

                        this.setState({
                            weatherForecastData: daysData,
                            consultForecastData: false,
                            weatherForecastCoordinate: result.city
                        });
                        if (this.drawCreateToolbar) {
                            this.drawCreateToolbar.disable();
                        }
                    }
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    toggleHoverForecast = (value) => {
        this.setState({
            hoverForecast: value,
        });
    };

    handleTabChange = (event, newValue) => {
        this.setState({ selectedInfo: newValue });
    }

    handleTabHistoricChange = (event, newValue) => {
        this.setState({ selectedHistoricType: newValue });
    };

    toggleMapSize = () => {
        this.setState(prevState => ({
            isMapExpanded: !prevState.isMapExpanded
        }), () => {
            this.mymap.invalidateSize();
        });
    };

    getLastPointOfHour = (sliderData, selectedDate, hour, res) => {
        const selectedDateStr = Moment(selectedDate).format(res.FORMAT_DATA);
        const selectedHourStr = String(hour).padStart(2, '0');

        const hourPoints = (Array.isArray(sliderData) ? sliderData : []).filter((point) => {
            const pointMoment = Moment(point.datetime);
            const pointDateStr = pointMoment.format(res.FORMAT_DATA);
            const pointHourStr = pointMoment.format('HH');
            return pointDateStr === selectedDateStr && pointHourStr === selectedHourStr;
        });

        if (!hourPoints.length) return null;

        hourPoints.sort((a, b) => Moment(a.datetime).valueOf() - Moment(b.datetime).valueOf());
        return hourPoints[hourPoints.length - 1];
    };

    handleCardClick = (hour) => {
        const { sliderData, selectedDate } = this.state;
        const { res } = this.props;

        const selectedDateStr = Moment(selectedDate).format(res.FORMAT_DATA);
        const selectedHourStr = String(hour).padStart(2, '0');
        const selectedDateTimeLabel = `${selectedDateStr} ${selectedHourStr}:00`;

        const hourPoints = (Array.isArray(sliderData) ? sliderData : []).filter((point) => {
            const pointMoment = Moment(point.datetime);
            return (
                pointMoment.format(res.FORMAT_DATA) === selectedDateStr &&
                pointMoment.format('HH') === selectedHourStr
            );
        });

        if (!hourPoints.length) {
            this.setState({
                datetimeL: selectedDateTimeLabel,
                autoUpdate: false,
                selectedTime: hour
            });
            this.stopAutoUpdate();
            return;
        }

        hourPoints.sort((a, b) => Moment(a.datetime).valueOf() - Moment(b.datetime).valueOf());
        const lastPoint = hourPoints[hourPoints.length - 1];

        const airTemperature = Number(lastPoint.air_temperature);
        const surfaceTemperature = Number(lastPoint.temperature);

        let thermalInversionLabel = res.DISABILITADO;
        if (Number.isFinite(airTemperature) && Number.isFinite(surfaceTemperature)) {
            if (airTemperature - 5 > surfaceTemperature) thermalInversionLabel = res.GRANDES_INVERSÃO_TERMICA;
            else if (airTemperature - 1 > surfaceTemperature) thermalInversionLabel = res.PODE_ESTAR_INVERSÃO_TERMICA;
            else thermalInversionLabel = res.NAO_INVERSÃO_TERMICA;
        }

        const deltaTValue =
            lastPoint.delta_t !== undefined && lastPoint.delta_t !== null
                ? Number(lastPoint.delta_t)
                : null;

        let flightConditions = res.CONDICOES_ARRISCADAS;
        if (deltaTValue !== null && Number.isFinite(deltaTValue)) {
            if (deltaTValue >= 2 && deltaTValue <= 8) flightConditions = res.CONDICOES_ADEQUADAS;
            else if (deltaTValue > 10) flightConditions = res.CONDICOES_INADEQUADAS;
            else flightConditions = res.CONDICOES_ARRISCADAS;
        }

        const temperatureFixed = Number(lastPoint.temperature || 0).toFixed(1);
        const airTemperatureFixed = Number(lastPoint.air_temperature || 0).toFixed(1);

        this.setState({
            flightConditions,
            datetimeL: selectedDateTimeLabel,

            humidityL: Number(lastPoint.humidity || 0).toFixed(0),
            air_humidityL: Number(lastPoint.air_humidity || 0).toFixed(0),

            temperatureL: temperatureFixed,
            air_temperatureL: airTemperatureFixed,

            heightL: Number(lastPoint.height || 0).toFixed(0),
            pressureL: Number(lastPoint.pressure || 0).toFixed(0),

            wind_speedL: Number(lastPoint.wind_speed || 0).toFixed(0),
            wind_directionL: Number(lastPoint.wind_direction || 0).toFixed(0),

            delta_tL: deltaTValue !== null && Number.isFinite(deltaTValue) ? deltaTValue.toFixed(1) : '0.0',
            thermalInversionL: thermalInversionLabel,

            solarL:
                lastPoint.solar !== undefined && lastPoint.solar !== null
                    ? Number(lastPoint.solar || 0).toFixed(1)
                    : '0.0',

            rainL: (Number(lastPoint.rain) || 0) > 0 ? 1 : 0,

            autoUpdate: false,
            selectedTime: hour
        });

        this.stopAutoUpdate();
    };

    readWeatherDataByMonth = () => {
        const { idStationSelected, selectedMonth } = this.state;
        const [year, month] = selectedMonth.split('-');
        const startDate = new Date(Number(year), Number(month) - 1, 1, 0, 0, 0, 0).getTime();
        const endDate = new Date(Number(year), Number(month), 1, 0, 0, 0, 0).getTime();

        const apiUrl = `${Config.server}/weather_data/monthly/${idStationSelected}/${startDate}/${endDate}`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    if (result.length > 0) {
                        this.setState(
                            { monthlyData: result, noData: false, selectedInfo: 'temperatureMonth', isLoading: false },
                            () => {
                                this.generateMonthlyChart();
                            }
                        );
                    } else if (result.length === 0) {
                        this.setState({ noData: true })
                        notification.open({
                            message: this.props.res.ATENCAO,
                            description: this.props.res.ERRO_ESTACAO,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    readWeatherDataByYear = () => {
        const { idStationSelected, selectedYear } = this.state;

        const startDate = new Date(Number(selectedYear), 0, 1, 0, 0, 0, 0).getTime();
        const endDate = new Date(Number(selectedYear) + 1, 0, 1, 0, 0, 0, 0).getTime();

        const apiUrl = `${Config.server}/weather_data/yearly/${idStationSelected}/${startDate}/${endDate}`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    if (result.length > 0) {
                        this.setState(
                            { yearlyData: result, noData: false, selectedInfo: 'temperatureYear', isLoading: false },
                            () => {
                                this.generateYearlyChart();
                            }
                        );
                    } else if (result.length === 0) {
                        this.setState({ noData: true })
                        notification.open({
                            message: this.props.res.ATENCAO,
                            description: this.props.res.ERRO_ESTACAO,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    readWeatherDataByWeek = () => {
        const { idStationSelected, selectedWeekStart } = this.state;

        const weekStartDate = new Date(selectedWeekStart);
        const startDate = weekStartDate.getTime();

        const weekEndDate = new Date(weekStartDate);
        weekEndDate.setUTCDate(weekEndDate.getUTCDate() + 7);
        const endDate = weekEndDate.getTime();

        const apiUrl = `${Config.server}/weather_data/weekly/${idStationSelected}/${startDate}/${endDate}`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    if (result.length > 0) {
                        this.setState(
                            { weeklyData: result, noData: false, selectedInfo: 'temperatureWeek', isLoading: false },
                            () => {
                                this.generateWeeklyChart();
                            }
                        );
                    } else if (result.length === 0) {
                        this.setState({ noData: true })
                        notification.open({
                            message: this.props.res.ATENCAO,
                            description: this.props.res.ERRO_ESTACAO,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    generateMonthlyChart() {
        const { res } = this.props;
        const { selectedInfo, monthlyData, windSpeedUnit } = this.state;
        this.setCurrentChart('generateMonthlyChart');
        let modulesLabel = '';
        let labels;

        labels = monthlyData.map(module =>
            String(new Date(module.day).getUTCDate()).padStart(2, '0')
        );

        if (selectedInfo === 'temperatureMonth') {
            const minTemperatureData = monthlyData
                .filter(module => module.min_temperature !== -99 && module.min_temperature != null)
                .map(module => (res.LINGUA === 'en-US' ?
                    tools.round(tools.c_to_f(module.min_temperature), 1) : tools.round(module.min_temperature, 1)));

            const maxTemperatureData = monthlyData
                .filter(module => module.max_temperature !== -99 && module.max_temperature != null)
                .map(module => (res.LINGUA === 'en-US' ?
                    tools.round(tools.c_to_f(module.max_temperature), 1) : tools.round(module.max_temperature, 1)));

            const minTempIndex = minTemperatureData.findIndex(temp => temp === Math.min(...minTemperatureData));
            const maxTempIndex = maxTemperatureData.findIndex(temp => temp === Math.max(...maxTemperatureData));

            const minTempDay = labels[minTempIndex];
            const maxTempDay = labels[maxTempIndex];

            modulesLabel = `
                ${tools.replaceString(res._DIA_TEMPERATURA_MINIMA_, minTempDay, minTemperatureData[minTempIndex], res.LINGUA === 'en-US' ? res.F : res.C)}
                ${tools.replaceString(res._DIA_TEMPERATURA_MAXIMA_, maxTempDay, maxTemperatureData[maxTempIndex], res.LINGUA === 'en-US' ? res.F : res.C)}
            `;

            const minTemperatureDataset = {
                label: tools.replaceString(res._TEMPERATURA_MINIMA_, res.LINGUA === 'en-US' ? res.F : res.C),
                data: minTemperatureData,
                yAxisID: 'temperature',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxTemperatureDataset = {
                label: tools.replaceString(res._TEMPERATURA_MAXIMA_, res.LINGUA === 'en-US' ? res.F : res.C),
                data: maxTemperatureData,
                yAxisID: 'temperature',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartTemperatureMonth');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minTemperatureDataset, maxTemperatureDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            temperature: {
                                id: 'temperature',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: tools.replaceString(res._TEMPERATURA_UNI, res.C),
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'humidityMonth') {
            const minHumidityData = monthlyData
                .filter(module => module.min_humidity !== -99 && module.min_humidity != null)
                .map(module => parseFloat(module.min_humidity.toFixed(1)));

            const maxHumidityData = monthlyData
                .filter(module => module.max_humidity !== -99 && module.max_humidity != null)
                .map(module => parseFloat(module.max_humidity.toFixed(1)));

            const minHumidityIndex = minHumidityData.findIndex(temp => temp === Math.min(...minHumidityData));
            const maxHumidityIndex = maxHumidityData.findIndex(temp => temp === Math.max(...maxHumidityData));

            const minHumDay = labels[minHumidityIndex];
            const maxHumDay = labels[maxHumidityIndex];

            modulesLabel = `
                ${tools.replaceString(res._DIA_UMIDADE_MINIMA_, minHumDay, minHumidityData[minHumidityIndex])}
                ${tools.replaceString(res._DIA_UMIDADE_MAXIMA_, maxHumDay, maxHumidityData[maxHumidityIndex])}
            `;

            const minHumidityDataset = {
                label: res.UMIDADE_MINIMA_,
                data: minHumidityData,
                yAxisID: 'humidity',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxHumidityDataset = {
                label: res.UMIDADE_MAXIMA_,
                data: maxHumidityData,
                yAxisID: 'humidity',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartHumidityMonth');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minHumidityDataset, maxHumidityDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            humidity: {
                                id: 'humidity',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: res.HUMIDADE_UNI,
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'pressureMonth') {
            const minPressureData = monthlyData
                .filter(module => module.min_pressure !== -99 && module.min_pressure != null)
                .map(module => parseFloat(module.min_pressure.toFixed(1)));

            const maxPressureData = monthlyData
                .filter(module => module.max_pressure !== -99 && module.max_pressure != null)
                .map(module => parseFloat(module.max_pressure.toFixed(1)));

            const minPressureIndex = minPressureData.findIndex(temp => temp === Math.min(...minPressureData));
            const maxPressureIndex = maxPressureData.findIndex(temp => temp === Math.max(...maxPressureData));

            const minPressureDay = labels[minPressureIndex];
            const maxPressureDay = labels[maxPressureIndex];

            modulesLabel = `
                ${tools.replaceString(res._DIA_PRESSAO_MINIMA_, minPressureDay, minPressureData[minPressureIndex])}
                ${tools.replaceString(res._DIA_PRESSAO_MAXIMA_, maxPressureDay, maxPressureData[maxPressureIndex])}
            `;

            const minPressureDataset = {
                label: res.PRESSAO_MINIMA_,
                data: minPressureData,
                yAxisID: 'pressure',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxPressureDataset = {
                label: res.PRESSAO_MAXIMA_,
                data: maxPressureData,
                yAxisID: 'pressure',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartPressureMonth');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minPressureDataset, maxPressureDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            pressure: {
                                id: 'pressure',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: res.PRESSAO_UNI,
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'windSpeedMonth') {
            const preferredUnit = this.state.windSpeedUnit;

            const minWindSpeedData = monthlyData
                .filter(module => module.min_wind_speed !== -99 && module.min_wind_speed != null)
                .map(module => (res.LINGUA === 'en-US' ?
                    preferredUnit === res.MPH ? tools.round(tools.mps_to_mph(module.min_wind_speed, 1)) : tools.round(tools.mps_to_fts(module.min_wind_speed, 1)) :
                    preferredUnit === res.KMH ? tools.round(tools.mps_to_kmh(module.min_wind_speed, 1)) : tools.round(module.min_wind_speed, 1)
                ));

            const maxWindSpeedData = monthlyData
                .filter(module => module.max_wind_speed !== -99 && module.max_wind_speed != null)
                .map(module => (res.LINGUA === 'en-US' ?
                    preferredUnit === res.MPH ? tools.round(tools.mps_to_mph(module.max_wind_speed, 1)) : tools.round(tools.mps_to_fts(module.max_wind_speed, 1)) :
                    preferredUnit === res.KMH ? tools.round(tools.mps_to_kmh(module.max_wind_speed, 1)) : tools.round(module.max_wind_speed, 1)
                ));

            const minWindSpeedIndex = minWindSpeedData.length > 0 ? minWindSpeedData.findIndex(temp => temp === Math.min(...minWindSpeedData)) : -1;
            const maxWindSpeedIndex = maxWindSpeedData.length > 0 ? maxWindSpeedData.findIndex(temp => temp === Math.max(...maxWindSpeedData)) : -1;

            const minWindSpeedDay = minWindSpeedIndex !== -1 ? labels[minWindSpeedIndex] : '-';
            const maxWindSpeedDay = maxWindSpeedIndex !== -1 ? labels[maxWindSpeedIndex] : '-';
            const minWindSpeed = minWindSpeedIndex !== -1 ? minWindSpeedData[minWindSpeedIndex] : '-';
            const maxWindSpeed = maxWindSpeedIndex !== -1 ? maxWindSpeedData[maxWindSpeedIndex] : '-';

            modulesLabel = `
                ${tools.replaceString(res._DIA_VEL_VENTO_MINIMA_, minWindSpeedDay, minWindSpeed !== '-' ?
                minWindSpeed + (res.LINGUA === 'en-US' ? preferredUnit === res.KMH ? ' ' + res.KMH : ' ' + res.MS : preferredUnit === res.MPH ? ' ' + res.MPH : ' ' + res.FTS) : '-')}
                ${tools.replaceString(res._DIA_VEL_VENTO_MAXIMA_, maxWindSpeedDay, maxWindSpeed !== '-' ?
                    maxWindSpeed + (res.LINGUA === 'en-US' ? preferredUnit === res.KMH ? ' ' + res.KMH : ' ' + res.MS : preferredUnit === res.MPH ? ' ' + res.MPH : ' ' + res.FTS) : '-')}
            `;

            const minWindSpeedDataset = {
                label: tools.replaceString(res._VEL_VENTO_MINIMA_, res.LINGUA === 'en-US' ? (preferredUnit === res.KMH ? res.KMH : res.MS) : (preferredUnit === res.MPH ? res.MPH : res.FTS)),
                data: minWindSpeedData,
                yAxisID: 'windSpeed',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxWindSpeedDataset = {
                label: tools.replaceString(res._VEL_VENTO_MAXIMA_, res.LINGUA === 'en-US' ? (preferredUnit === res.KMH ? res.KMH : res.MS) : (preferredUnit === res.MPH ? res.MPH : res.FTS)),
                data: maxWindSpeedData,
                yAxisID: 'windSpeed',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartWindSpeedMonth');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minWindSpeedDataset, maxWindSpeedDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            windSpeed: {
                                id: 'windSpeed',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: `${res.VENTO_VELOCIDADE} (${res.LINGUA === 'en-US' ? (preferredUnit === res.KMH ? res.KMH : res.MS) : (preferredUnit === res.MPH ? res.MPH : res.FTS)})`,
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'rainMonth') {
            const rainData = monthlyData
                .map(module => module.total_rain !== undefined && module.total_rain !== -99 && module.total_rain != null && module.total_rain >= 0
                    ? parseFloat(module.total_rain.toFixed(1))
                    : 0);

            const totalRainfall = rainData.reduce((acc, curr) => acc + curr, 0);
            //TODO: traducao...
            modulesLabel = `Total de chuva no mês: ${totalRainfall.toFixed(1)} mm`;

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartRainMonth');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Chuva diária (mm)',
                            data: rainData,
                            backgroundColor: '#FA9F34',
                            borderColor: '#FA9F34',
                            borderWidth: 1,
                            pointBackgroundColor: rainData.map(value => value === 0 ? '#FAB288' : '#FA9F34'),
                            pointBorderColor: rainData.map(value => value === 0 ? '#FAB288' : '#FA9F34'),
                            fill: false,
                        }],
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    color: 'white',
                                },
                                title: {
                                    display: true,
                                    text: `${res.CHUVA} (mm)`,
                                    color: 'white',
                                },
                            },
                            x: {
                                ticks: {
                                    color: 'white',
                                },
                            },
                        },
                        plugins: {
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                            tooltip: {
                                mode: 'index',
                                intersect: false,
                            },
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                        },
                        elements: {
                            line: {
                                tension: 0.1
                            },
                            point: {
                                radius: 3
                            }
                        },
                    },
                });
            }
        }
    }

    generateYearlyChart() {
        const { res } = this.props;
        const { selectedInfo, yearlyData, windSpeedUnit } = this.state;
        this.setCurrentChart('generateYearlyChart');
        let modulesLabel = '';
        let labels;

        const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

        if (selectedInfo === 'temperatureYear') {
            labels = yearlyData.map(module => `${monthNames[module.month - 1]}`);

            const minTemperatureData = yearlyData
                .filter(module => module.min_temperature !== -99 && module.min_temperature != null)
                .map(module => parseFloat(module.min_temperature.toFixed(1)));

            const maxTemperatureData = yearlyData
                .filter(module => module.max_temperature !== -99 && module.max_temperature != null)
                .map(module => parseFloat(module.max_temperature.toFixed(1)));

            const minTempIndex = minTemperatureData.findIndex(temp => temp === Math.min(...minTemperatureData));
            const maxTempIndex = maxTemperatureData.findIndex(temp => temp === Math.max(...maxTemperatureData));

            const minTempMonth = labels[minTempIndex];
            const maxTempMonth = labels[maxTempIndex];

            modulesLabel = `
                Mês ${minTempMonth}, temperatura mínima: ${minTemperatureData[minTempIndex]} °C
                Mês ${maxTempMonth}, temperatura máxima: ${maxTemperatureData[maxTempIndex]} °C
            `;

            const minTemperatureDataset = {
                label: 'Temperatura Mínima (°C)',
                data: minTemperatureData,
                yAxisID: 'temperature',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxTemperatureDataset = {
                label: 'Temperatura Máxima (°C)',
                data: maxTemperatureData,
                yAxisID: 'temperature',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartTemperatureYear');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minTemperatureDataset, maxTemperatureDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            temperature: {
                                id: 'temperature',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: tools.replaceString(res._TEMPERATURA_UNI, res.C),
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'humidityYear') {
            labels = yearlyData.map(module => `${monthNames[module.month - 1]}`);

            const minHumidityData = yearlyData
                .filter(module => module.min_humidity !== -99 && module.min_humidity != null)
                .map(module => parseFloat(module.min_humidity.toFixed(1)));

            const maxHumidityData = yearlyData
                .filter(module => module.max_humidity !== -99 && module.max_humidity != null)
                .map(module => parseFloat(module.max_humidity.toFixed(1)));

            const minHumIndex = minHumidityData.findIndex(hum => hum === Math.min(...minHumidityData));
            const maxHumIndex = maxHumidityData.findIndex(hum => hum === Math.max(...maxHumidityData));

            const minHumMonth = labels[minHumIndex];
            const maxHumMonth = labels[maxHumIndex];

            modulesLabel = `
                Mês ${minHumMonth}, umidade mínima: ${minHumidityData[minHumIndex]} %
                Mês ${maxHumMonth}, umidade máxima: ${maxHumidityData[maxHumIndex]} %
            `;

            const minHumidityDataset = {
                label: 'Umidade Mínima (%)',
                data: minHumidityData,
                yAxisID: 'humidity',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxHumidityDataset = {
                label: 'Umidade Máxima (%)',
                data: maxHumidityData,
                yAxisID: 'humidity',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartHumidityYear');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minHumidityDataset, maxHumidityDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            humidity: {
                                id: 'humidity',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: res.HUMIDADE_UNI,
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'pressureYear') {
            labels = yearlyData.map(module => `${monthNames[module.month - 1]}`);

            const minPressureData = yearlyData
                .filter(module => module.min_pressure !== -99 && module.min_pressure != null)
                .map(module => parseFloat(module.min_pressure.toFixed(1)));

            const maxPressureData = yearlyData
                .filter(module => module.max_pressure !== -99 && module.max_pressure != null)
                .map(module => parseFloat(module.max_pressure.toFixed(1)));

            const minPressureIndex = minPressureData.findIndex(pressure => pressure === Math.min(...minPressureData));
            const maxPressureIndex = maxPressureData.findIndex(pressure => pressure === Math.max(...maxPressureData));

            const minPressureMonth = labels[minPressureIndex];
            const maxPressureMonth = labels[maxPressureIndex];

            modulesLabel = `
                Mês ${minPressureMonth}, pressão mínima: ${minPressureData[minPressureIndex]} hPa
                Mês ${maxPressureMonth}, pressão máxima: ${maxPressureData[maxPressureIndex]} hPa
            `;

            const minPressureDataset = {
                label: 'Pressão Mínima (hPa)',
                data: minPressureData,
                yAxisID: 'pressure',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxPressureDataset = {
                label: 'Pressão Máxima (hPa)',
                data: maxPressureData,
                yAxisID: 'pressure',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartPressureYear');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minPressureDataset, maxPressureDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            pressure: {
                                id: 'pressure',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: res.PRESSAO_UNI,
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'windSpeedYear') {
            const preferredUnit = this.state.windSpeedUnit;
            labels = yearlyData.map(module => `${monthNames[module.month - 1]}`);

            const minWindSpeedData = yearlyData
                .filter(module => module.min_wind_speed !== -99 && module.min_wind_speed != null)
                .map(module => {
                    const speed = parseFloat(module.min_wind_speed.toFixed(1));
                    return preferredUnit === 'km/h' ? parseFloat((speed * 3.6).toFixed(1)) : speed;
                });

            const maxWindSpeedData = yearlyData
                .filter(module => module.max_wind_speed !== -99 && module.max_wind_speed != null)
                .map(module => {
                    const speed = parseFloat(module.max_wind_speed.toFixed(1));
                    return preferredUnit === 'km/h' ? parseFloat((speed * 3.6).toFixed(1)) : speed;
                });

            const minWindSpeedIndex = minWindSpeedData.length > 0 ? minWindSpeedData.findIndex(speed => speed === Math.min(...minWindSpeedData)) : -1;
            const maxWindSpeedIndex = maxWindSpeedData.length > 0 ? maxWindSpeedData.findIndex(speed => speed === Math.max(...maxWindSpeedData)) : -1;

            const minWindSpeedMonth = minWindSpeedIndex !== -1 ? labels[minWindSpeedIndex] : '-';
            const maxWindSpeedMonth = maxWindSpeedIndex !== -1 ? labels[maxWindSpeedIndex] : '-';
            const minWindSpeed = minWindSpeedIndex !== -1 ? minWindSpeedData[minWindSpeedIndex] : '-';
            const maxWindSpeed = maxWindSpeedIndex !== -1 ? maxWindSpeedData[maxWindSpeedIndex] : '-';

            modulesLabel = `
                Mês ${minWindSpeedMonth}, vel. do vento mínima: ${minWindSpeed !== '-' ? minWindSpeed + (preferredUnit === 'km/h' ? ' km/h' : ' m/s') : '-'}
                Mês ${maxWindSpeedMonth}, vel. do vento máxima: ${maxWindSpeed !== '-' ? maxWindSpeed + (preferredUnit === 'km/h' ? ' km/h' : ' m/s') : '-'}
            `;

            const minWindSpeedDataset = {
                label: `Velocidade do Vento Mínima (${preferredUnit === 'km/h' ? 'km/h' : 'm/s'})`,
                data: minWindSpeedData,
                yAxisID: 'windSpeed',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxWindSpeedDataset = {
                label: `Velocidade do Vento Máxima (${preferredUnit === 'km/h' ? 'km/h' : 'm/s'})`,
                data: maxWindSpeedData,
                yAxisID: 'windSpeed',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartWindSpeedYear');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minWindSpeedDataset, maxWindSpeedDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            windSpeed: {
                                id: 'windSpeed',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: `${res.VENTO_VELOCIDADE} (${windSpeedUnit === 'km/h' ? ' km/h' : ' m/s'})`,
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'rainYear') {
            labels = yearlyData.map(module => `${monthNames[module.month - 1]}`);

            const rainData = yearlyData
                .map(module => module.total_rain !== undefined && module.total_rain !== -99 && module.total_rain != null && module.total_rain >= 0
                    ? parseFloat(module.total_rain.toFixed(1))
                    : 0);

            const totalRainfall = rainData.reduce((acc, curr) => acc + curr, 0);

            modulesLabel = `Total de chuva no ano: ${totalRainfall.toFixed(1)} mm`;

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartRainYear');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Chuva mensal (mm)',
                            data: rainData,
                            backgroundColor: '#FA9F34',
                            borderColor: '#FA9F34',
                            borderWidth: 1,
                            pointBackgroundColor: rainData.map(value => value === 0 ? '#FAB288' : '#FA9F34'),
                            pointBorderColor: rainData.map(value => value === 0 ? '#FAB288' : '#FA9F34'),
                            fill: false,
                        }],
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    color: 'white',
                                },
                                title: {
                                    display: true,
                                    text: `${res.CHUVA} (mm)`,
                                    color: 'white',
                                },
                            },
                            x: {
                                ticks: {
                                    color: 'white',
                                },
                            },
                        },
                        plugins: {
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                            tooltip: {
                                mode: 'index',
                                intersect: false,
                            },
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                        },
                        elements: {
                            line: {
                                tension: 0.1
                            },
                            point: {
                                radius: 3
                            }
                        },
                    },
                });
            }
        }
    }

    generateWeeklyChart() {
        const { res } = this.props;
        const { selectedInfo, weeklyData, windSpeedUnit } = this.state;
        this.setCurrentChart('generateWeeklyChart');
        let modulesLabel = '';
        let labels;
        const options = { month: '2-digit', day: '2-digit' };

        if (selectedInfo === 'temperatureWeek') {
            labels = weeklyData.map(module => new Date(module.date).toLocaleDateString('pt-BR', options));

            const minTemperatureData = weeklyData
                .filter(module => module.min_temperature !== -99 && module.min_temperature != null)
                .map(module => parseFloat(module.min_temperature.toFixed(1)));

            const maxTemperatureData = weeklyData
                .filter(module => module.max_temperature !== -99 && module.max_temperature != null)
                .map(module => parseFloat(module.max_temperature.toFixed(1)));

            const minTempIndex = minTemperatureData.findIndex(temp => temp === Math.min(...minTemperatureData));
            const maxTempIndex = maxTemperatureData.findIndex(temp => temp === Math.max(...maxTemperatureData));

            const minTempDay = labels[minTempIndex];
            const maxTempDay = labels[maxTempIndex];

            modulesLabel = `
                    Dia ${minTempDay}, temperatura mínima: ${minTemperatureData[minTempIndex]} °C
                    Dia ${maxTempDay}, temperatura máxima: ${maxTemperatureData[maxTempIndex]} °C
                `;

            const minTemperatureDataset = {
                label: 'Temperatura Mínima (°C)',
                data: minTemperatureData,
                yAxisID: 'temperature',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxTemperatureDataset = {
                label: 'Temperatura Máxima (°C)',
                data: maxTemperatureData,
                yAxisID: 'temperature',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartTemperatureWeek');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minTemperatureDataset, maxTemperatureDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            temperature: {
                                id: 'temperature',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: tools.replaceString(res._TEMPERATURA_UNI, res.C),
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'humidityWeek') {
            labels = weeklyData.map(module => new Date(module.date).toLocaleDateString('pt-BR', options));

            const minHumidityData = weeklyData
                .filter(module => module.min_humidity !== -99 && module.min_humidity != null)
                .map(module => parseFloat(module.min_humidity.toFixed(1)));

            const maxHumidityData = weeklyData
                .filter(module => module.max_humidity !== -99 && module.max_humidity != null)
                .map(module => parseFloat(module.max_humidity.toFixed(1)));

            const minHumIndex = minHumidityData.findIndex(hum => hum === Math.min(...minHumidityData));
            const maxHumIndex = maxHumidityData.findIndex(hum => hum === Math.max(...maxHumidityData));

            const minHumDay = labels[minHumIndex];
            const maxHumDay = labels[maxHumIndex];

            modulesLabel = `
                    Dia ${minHumDay}, umidade mínima: ${minHumidityData[minHumIndex]} %
                    Dia ${maxHumDay}, umidade máxima: ${maxHumidityData[maxHumIndex]} %
                `;

            const minHumidityDataset = {
                label: 'Umidade Mínima (%)',
                data: minHumidityData,
                yAxisID: 'humidity',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxHumidityDataset = {
                label: 'Umidade Máxima (%)',
                data: maxHumidityData,
                yAxisID: 'humidity',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartHumidityWeek');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minHumidityDataset, maxHumidityDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            humidity: {
                                id: 'humidity',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: res.HUMIDADE_UNI,
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'pressureWeek') {
            labels = weeklyData.map(module => new Date(module.date).toLocaleDateString('pt-BR', options));

            const minPressureData = weeklyData
                .filter(module => module.min_pressure !== -99 && module.min_pressure != null)
                .map(module => parseFloat(module.min_pressure.toFixed(1)));

            const maxPressureData = weeklyData
                .filter(module => module.max_pressure !== -99 && module.max_pressure != null)
                .map(module => parseFloat(module.max_pressure.toFixed(1)));

            const minPressureIndex = minPressureData.findIndex(pressure => pressure === Math.min(...minPressureData));
            const maxPressureIndex = maxPressureData.findIndex(pressure => pressure === Math.max(...maxPressureData));

            const minPressureDay = labels[minPressureIndex];
            const maxPressureDay = labels[maxPressureIndex];

            modulesLabel = `
                    Dia ${minPressureDay}, pressão mínima: ${minPressureData[minPressureIndex]} hPa
                    Dia ${maxPressureDay}, pressão máxima: ${maxPressureData[maxPressureIndex]} hPa
                `;

            const minPressureDataset = {
                label: 'Pressão Mínima (hPa)',
                data: minPressureData,
                yAxisID: 'pressure',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxPressureDataset = {
                label: 'Pressão Máxima (hPa)',
                data: maxPressureData,
                yAxisID: 'pressure',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartPressureWeek');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minPressureDataset, maxPressureDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            pressure: {
                                id: 'pressure',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: res.PRESSAO_UNI,
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'windSpeedWeek') {
            const preferredUnit = this.state.windSpeedUnit;
            labels = weeklyData.map(module => new Date(module.date).toLocaleDateString('pt-BR', options));

            const minWindSpeedData = weeklyData
                .filter(module => module.min_wind_speed !== -99 && module.min_wind_speed != null)
                .map(module => {
                    const speed = parseFloat(module.min_wind_speed.toFixed(1));
                    return preferredUnit === 'km/h' ? parseFloat((speed * 3.6).toFixed(1)) : speed;
                });

            const maxWindSpeedData = weeklyData
                .filter(module => module.max_wind_speed !== -99 && module.max_wind_speed != null)
                .map(module => {
                    const speed = parseFloat(module.max_wind_speed.toFixed(1));
                    return preferredUnit === 'km/h' ? parseFloat((speed * 3.6).toFixed(1)) : speed;
                });

            const minWindSpeedIndex = minWindSpeedData.length > 0 ? minWindSpeedData.findIndex(speed => speed === Math.min(...minWindSpeedData)) : -1;
            const maxWindSpeedIndex = maxWindSpeedData.length > 0 ? maxWindSpeedData.findIndex(speed => speed === Math.max(...maxWindSpeedData)) : -1;

            const minWindSpeedDay = minWindSpeedIndex !== -1 ? labels[minWindSpeedIndex] : '-';
            const maxWindSpeedDay = maxWindSpeedIndex !== -1 ? labels[maxWindSpeedIndex] : '-';
            const minWindSpeed = minWindSpeedIndex !== -1 ? minWindSpeedData[minWindSpeedIndex] : '-';
            const maxWindSpeed = maxWindSpeedIndex !== -1 ? maxWindSpeedData[maxWindSpeedIndex] : '-';

            modulesLabel = `
                Dia ${minWindSpeedDay}, vel. do vento mínima: ${minWindSpeed !== '-' ? minWindSpeed + (preferredUnit === 'km/h' ? ' km/h' : ' m/s') : '-'}
                Dia ${maxWindSpeedDay}, vel. do vento máxima: ${maxWindSpeed !== '-' ? maxWindSpeed + (preferredUnit === 'km/h' ? ' km/h' : ' m/s') : '-'}
            `;

            const minWindSpeedDataset = {
                label: `Velocidade do Vento Mínima (${preferredUnit === 'km/h' ? 'km/h' : 'm/s'})`,
                data: minWindSpeedData,
                yAxisID: 'windSpeed',
                backgroundColor: '#FA9F34',
                borderColor: '#FA9F34',
                borderWidth: 1
            };

            const maxWindSpeedDataset = {
                label: `Velocidade do Vento Máxima (${preferredUnit === 'km/h' ? 'km/h' : 'm/s'})`,
                data: maxWindSpeedData,
                yAxisID: 'windSpeed',
                backgroundColor: '#FA3834',
                borderColor: '#FA3834',
                borderWidth: 1
            };

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartWindSpeedWeek');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels,
                        datasets: [minWindSpeedDataset, maxWindSpeedDataset]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                        },
                        scales: {
                            windSpeed: {
                                id: 'windSpeed',
                                type: 'linear',
                                position: 'left',
                                title: {
                                    display: true,
                                    text: `${res.VENTO_VELOCIDADE} (${windSpeedUnit === 'km/h' ? ' km/h' : ' m/s'})`,
                                    color: 'white',
                                },
                                ticks: {
                                    color: 'lightgray',
                                }
                            },
                            x: {
                                ticks: {
                                    color: 'lightgray',
                                }
                            }
                        },
                    }
                });
            }
        } else if (selectedInfo === 'rainWeek') {
            labels = weeklyData.map(module => new Date(module.date).toLocaleDateString('pt-BR', options));

            const rainData = weeklyData
                .map(module => module.total_rain !== undefined && module.total_rain !== -99 && module.total_rain != null && module.total_rain >= 0
                    ? parseFloat(module.total_rain.toFixed(1))
                    : 0);

            const totalRainfall = rainData.reduce((acc, curr) => acc + curr, 0);

            modulesLabel = `Total de chuva na semana: ${totalRainfall.toFixed(1)} mm`;

            if (this.barChart) {
                this.barChart.destroy();
            }

            const chartElement = document.getElementById('chartRainWeek');
            if (chartElement) {
                const ctx = chartElement.getContext('2d');
                this.barChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Chuva diária (mm)',
                            data: rainData,
                            backgroundColor: '#FA9F34',
                            borderColor: '#FA9F34',
                            borderWidth: 1,
                            pointBackgroundColor: rainData.map(value => value === 0 ? '#FAB288' : '#FA9F34'),
                            pointBorderColor: rainData.map(value => value === 0 ? '#FAB288' : '#FA9F34'),
                            fill: false,
                        }],
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    color: 'white',
                                },
                                title: {
                                    display: true,
                                    text: `${res.CHUVA} (mm)`,
                                    color: 'white',
                                },
                            },
                            x: {
                                ticks: {
                                    color: 'white',
                                },
                            },
                        },
                        plugins: {
                            legend: {
                                labels: {
                                    color: 'white',
                                }
                            },
                            tooltip: {
                                mode: 'index',
                                intersect: false,
                            },
                            title: {
                                display: true,
                                text: modulesLabel,
                                color: 'white',
                                position: 'bottom',
                            },
                        },
                        elements: {
                            line: {
                                tension: 0.1
                            },
                            point: {
                                radius: 3
                            }
                        },
                    },
                });
            }
        }
    }

    handleTabClick = (selectedInfo) => {
        this.setState({
            selectedInfo,
            weeklyData: [],
            monthlyData: [],
            yearlyData: [],
            filterStations: []
        });
    };

    toggleWindSpeedUnit = () => {
        this.setState(prevState => {
            const newUnit = prevState.windSpeedUnit === 'km/h' ? 'm/s' : 'km/h';

            localStorage.setItem('windSpeedUnit', newUnit);

            return {
                windSpeedUnit: newUnit,
                wind_speedL: this.convertWindSpeed(prevState.wind_speedL, prevState.windSpeedUnit, newUnit)
            };
        });
    };

    convertWindSpeed = (value, currentUnit) => {
        if (currentUnit === 'km/h') {
            return (value / 3.6).toFixed(1);
        } else {
            return (value * 3.6).toFixed(1);
        }
    };

    setCurrentChart = (chartName) => {
        this.setState({ currentChart: chartName });
    }

    renderCurrentChart = () => {
        const { currentChart } = this.state;
        if (currentChart === 'generateChart') {
            this.generateChart();
        } else if (currentChart === 'generateMonthlyChart') {
            this.generateMonthlyChart();
        } else if (currentChart === 'generateYearlyChart') {
            this.generateYearlyChart();
        } else if (currentChart === 'generateWeeklyChart') {
            this.generateWeeklyChart();
        }
    }

    loadFiledb = file => {
        this.guidUpload = '';
        let filePath = file.target.files[0];
        let ext = fileName => fileName.split(".").pop();

        if (ext(filePath.name.toLowerCase()) === 'zip') {
            this.uploadFiledb(filePath);
        }
        document.getElementById('teste_db').value = null;
    };

    uploadFiledb = (file) => {
        notification.open({
            message: "Arquivo ZIP selecionado",
            description: `Você selecionou: ${file.name}`,
            icon: <MaterialIcon icon="add" className="iconMap" />,
        });

        this.setState({ progress: true });

        let apiUrl = Config.server + '/upload_db';
        let method = 'POST';

        const formData = new FormData();
        formData.append('file', file);
        if (this.guidUpload) {
            formData.append('guid', this.guidUpload);
        }

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then(
                (resData) => {
                    if (resData.status !== 200) throw resData;
                    return resData.json();
                })
            .then(
                (result) => {
                    this.setState({ progress: false });
                    window.location.reload();
                    notification.open({
                        message: "Importação de arquivo concluida",
                        icon: <MaterialIcon icon="add" className="iconMap" />,
                    });
                },
                (error) => {
                    this.setState({ progress: false });
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            )
    };

    getLastSampleOfHour = (hour, selectedDay, sliderData) => {
        const day = Moment(selectedDay).startOf('day');
        const hourData = (sliderData || [])
            .filter(d => {
                if (d.air_temperature === null || d.air_temperature === undefined) return false;
                const m = Moment.utc(d.datetime).local();
                return m.isSame(day, 'day') && m.hour() === hour;
            })
            .sort((a, b) => {
                const ma = Moment.utc(a.datetime).local().valueOf();
                const mb = Moment.utc(b.datetime).local().valueOf();
                return ma - mb;
            });

        return hourData.length ? hourData[hourData.length - 1] : null;
    };


    render() {
        const { classes, res } = this.props;
        const { stations, stationData, idStationSelected, autoUpdate, goTo, consultForecastData, showData, disable, maxSelectedDate, selectedDate, filterStations, selectedInfo,
            addressStationL, lat, lng, selectedTime, latL, lngL, nameL, heightL, datetimeL, air_humidityL, air_temperatureL, wind_directionL, pressureL, wind_speedL, rainL, solarL,
            flightConditions, delta_tL, thermalInversionL, weatherForecastData, isOpenStation, isOpenWeatherForecast, hasRain, hasSolar, isMapExpanded, loading, selectedHistoricType,
            monthlyData, selectedMonth, selectedYear, yearlyData, weeklyData, selectedWeekStart, selectedWeekEnd, temperatureL, windSpeedUnit, refreshInterval
        } = this.state;

        if (isOpenStation && isOpenWeatherForecast) {
            if (stationData[0]) {
                this.mymap.setView([stationData[0].lat, parseFloat(stationData[0].lng) - parseFloat('00.037')], 14);
            }
        }

        return (
            <div>
                <div className="divContent pageTitleContainer" style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="containerTitle">
                        <h1 className="pageTitle">{res.CLIMA}</h1>
                    </div>
                    <Button
                        onClick={this.toggleWindSpeedUnit}
                        variant="contained"
                        title={this.state.windSpeedUnit === 'km/h' ? 'Direção do vento em km/h' : 'Direção do vento em m/s'}
                        style={{ backgroundColor: 'rgb(250, 125, 52)', color: 'white' }}
                    >
                        {this.state.windSpeedUnit === 'km/h' ? 'KM/H ' : 'M/S '} <SpeedIcon style={{ marginLeft: '0.25rem' }} />
                    </Button>
                    <input
                        accept=".zip"
                        style={{ display: 'none' }}
                        id="teste_db"
                        type="file"
                        onChange={this.loadFiledb}
                    />
                    <label htmlFor="teste_db">
                        <Button component="span" variant="contained" style={{ padding: '2.5px', backgroundColor: 'rgb(250, 125, 52)', color: 'white', marginLeft: '.4rem' }} className="popUpButton" title={'IMPORTAR BANCO DE DADOS'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" viewBox="-4 -4 24 24">
                                <path d="M8.5 9.5a.5.5 0 0 1-1 0V5.707L6.354 7.354a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 5.707V9.5z"
                                    transform="scale(1.4) translate(-2.4, -1)" />
                                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                            </svg>
                        </Button>
                    </label>

                    <FormControl style={{ margin: '0 3rem', width: '16rem', textAlign: 'center' }}>
                        <InputLabel id="station-select-label" style={{ fontSize: '0.875rem', color: '#000' }}>
                            Estação
                        </InputLabel>
                        <Select
                            labelId="station-select-label"
                            id="station-select"
                            value={idStationSelected}
                            onChange={(event) => this.handleListItemClick(event.target.value)}
                            MenuProps={{
                                getContentAnchorEl: null,
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                            }}
                            style={{ width: 'fit-content' }}
                        >
                            {stations.map((item) => {
                                const station = stationData.find((filterStation) => filterStation.id_source === item.id);

                                return (
                                    <MenuItem
                                        key={item.id}
                                        value={item.id}
                                        style={{ color: item.id === idStationSelected ? 'selectedColor' : 'defaultColor' }}
                                    >
                                        {item.name}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                    <div className="leftTop" style={{ paddingLeft: autoUpdate ? '2.5rem' : '0', display: 'flex' }}>
                        <FormControl style={{ marginRight: '1rem' }}>
                            <InputLabel id="update-interval-label" style={{ fontSize: '0.875rem', color: '#000' }}>
                                {res.ATUALIZACAO}
                            </InputLabel>
                            <Select
                                value={refreshInterval / 60000}
                                onChange={this.handleIntervalChange}
                            >
                                {[1, 3, 5, 10, 15].map((interval) => (
                                    <MenuItem key={interval} value={interval}>
                                        {interval} min
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {autoUpdate ? (
                            <Button
                                style={{
                                    backgroundColor: 'rgb(250, 125, 52)',
                                    color: 'white',
                                    fontSize: '1.5rem',
                                    border: '1px solid rgba(0, 0, 0, 0.23)',
                                }}
                                title="Desativar atualização automática"
                                onClick={this.toggleAutoUpdate}
                            >
                                <UpdateIcon />
                            </Button>
                        ) : (
                            <Button
                                style={{
                                    fontSize: '1.5rem',
                                    border: '1px solid rgba(0, 0, 0, 0.23)',
                                }}
                                title="Ativar atualização automática"
                                onClick={this.toggleAutoUpdate}
                            >
                                <UpdateIcon />
                            </Button>
                        )}
                    </div>
                </div>
                <div className="maxVH" style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <div style={{ width: '78.25%', marginRight: '0.5rem' }}>
                            {loading ?
                                <div style={{ backgroundColor: 'rgb(52, 58, 64)', padding: '1rem', height: '10.75rem', borderRadius: '0.5rem' }}>
                                    <div style={{ display: 'flex', justifyContent: 'start' }}>
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: '0' }}
                                            width={240}
                                            height={24}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: '0' }}
                                            height={80}
                                            width={120}
                                        />
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: '0' }}
                                            height={80}
                                            width={120}
                                        />
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: '0' }}
                                            height={80}
                                            width={120}
                                        />
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: '0' }}
                                            height={80}
                                            width={120}
                                        />
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: '0' }}
                                            height={80}
                                            width={120}
                                        />
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: '0' }}
                                            height={80}
                                            width={120}
                                        />
                                    </div>
                                    <Skeleton variant="text" style={{ margin: '0' }} height={40} />
                                </div>
                                :
                                <div style={{ backgroundColor: 'rgb(52, 58, 64)', padding: '0.25rem', height: '10.75rem', borderRadius: '0.5rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 0.5rem' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                            <span style={{ color: 'white', fontSize: '1.5rem' }}>{datetimeL}</span>
                                            <>
                                                {addressStationL === 255 ? (
                                                    rainL > 0 ? (
                                                        solarL < 3 ? (
                                                            <img style={{ width: '3.5rem', padding: '0.5rem' }} src={rainNight} alt="imagem chuva noite" />
                                                        ) : (
                                                            <img style={{ width: '3.5rem', padding: '0.5rem' }} src={rainDay} alt="imagem chuva dia" />
                                                        )
                                                    ) : (
                                                        solarL < 3 ? (
                                                            <img style={{ width: '3.5rem', padding: '0.5rem' }} src={lua} alt="imagem lua" />
                                                        ) : (
                                                            <img style={{ width: '3.5rem', padding: '0.5rem' }} src={sun} alt="imagem sol" />
                                                        )
                                                    )
                                                ) : addressStationL === 200 && rainL > 0 ? (
                                                    <img style={{ width: '3.5rem', padding: '0.5rem' }} src={chuva} alt="imagem chuva" />
                                                ) : null}
                                            </>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <span></span>
                                            {air_temperatureL && air_temperatureL !== 'Sem conexão' ?
                                                <span style={{ color: 'white', fontSize: '1.75rem' }}>{air_temperatureL}<span style={{ fontSize: '1rem' }}> °C</span></span>
                                                :
                                                <span style={{ color: 'white', fontSize: '1.75rem' }}>-</span>
                                            }
                                            <span style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.TEMPERATURA_}</span>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <span></span>
                                            {air_humidityL && air_humidityL !== 'Sem conexão' ?
                                                <span style={{ color: 'white', fontSize: '1.75rem' }}>{air_humidityL}<span style={{ fontSize: '1rem' }}> %</span></span>
                                                :
                                                <span style={{ color: 'white', fontSize: '1.75rem' }}>-</span>
                                            }
                                            <span style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.UMIDADE_}</span>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <span></span>
                                            {wind_speedL && wind_speedL !== 'Sem conexão' ?
                                                <span style={{ color: 'white', fontSize: '1.75rem' }}>{wind_speedL}<span style={{ fontSize: '1rem' }}> {windSpeedUnit === 'km/h' ? 'km/h' : 'm/s'}</span></span>
                                                :
                                                <span style={{ color: 'white', fontSize: '1.75rem' }}>-</span>
                                            }
                                            <span style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.VENTO_VELOCIDADE}</span>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
                                            {delta_tL && delta_tL !== 'Sem conexão' ?
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <span style={{ color: flightConditions === 'Condições adequadas' ? 'lawngreen' : flightConditions === 'Condições inadequadas' ? 'red' : 'yellow', fontSize: '1.75rem' }}>{delta_tL}</span>
                                                    <span style={{ color: flightConditions === 'Condições adequadas' ? 'lawngreen' : flightConditions === 'Condições inadequadas' ? 'red' : 'yellow' }}>{flightConditions}</span>
                                                </div>
                                                :
                                                <span style={{ color: 'white', fontSize: '1.75rem' }}>-</span>
                                            }
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.DELTA_T}</span>
                                                <Tooltip
                                                    title={
                                                        <div
                                                            style={{
                                                                backgroundColor: '#fff',
                                                                padding: '10px',
                                                                borderRadius: '4px',
                                                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                width: '22.5rem'
                                                            }}
                                                        >
                                                            <DeltaTHeat
                                                                atual={delta_tL}
                                                                humidade={air_humidityL}
                                                                temperatura={air_temperatureL}
                                                                res={res}
                                                            />
                                                        </div>
                                                    }
                                                    placement="top"
                                                    arrow
                                                    classes={{ tooltip: classes.customWidthTooltip }}
                                                >
                                                    <HelpOutlineIcon style={{ color: 'rgb(250, 125, 52)', marginBottom: '0', width: '1.25rem', marginLeft: '0.5rem' }} />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
                                            {wind_directionL && wind_directionL !== 'Sem conexão' ?
                                                <div style={{ display: 'flex', textAlign: 'center' }}>
                                                    <span></span>
                                                    <span style={{ color: 'white', fontSize: '1.75rem', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                                                        <p style={{ marginRight: '1rem', marginBottom: '0' }}>{`${wind_directionL} °`}</p>
                                                        <div className="windDirectionIcon">
                                                            <div className="circle">
                                                                <div className="windDirection north">N</div>
                                                                <div className="windDirection south">S</div>
                                                                <div className="windDirection east">L</div>
                                                                <div className="windDirection west">O</div>
                                                            </div>
                                                            <div className="windDirectionArrow" style={{ transform: `rotate(${wind_directionL}deg)`, padding: '0.5rem 0 0.25rem 0' }}>
                                                                <NavigationIcon style={{ fontSize: '1rem', color: 'white' }} />
                                                            </div>
                                                        </div>
                                                    </span>
                                                </div>
                                                :
                                                <span style={{ color: 'white', fontSize: '1.75rem' }}>-</span>
                                            }
                                            <span style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.DIRECAO_VENTO}</span>
                                        </div>
                                    </div>
                                    <div className="historyCardContainer">
                                        {Array.from({ length: 24 }, (_, index) => {
                                            const hour = index;
                                            const isSelected = selectedTime === hour;
                                            const today = Moment().startOf('day');
                                            const selectedDay = Moment(selectedDate).startOf('day');
                                            const isToday = today.isSame(selectedDay, 'day');

                                            let isDisabled = false;
                                            if (isToday) {
                                                isDisabled = hour > Moment().hour();
                                            } else if (selectedDay.isBefore(today, 'day')) {
                                                isDisabled = false;
                                            } else {
                                                isDisabled = true;
                                            }

                                            const stationData = this.getLastSampleOfHour(hour, selectedDay, this.state.sliderData);
                                            const temperature = stationData ? Number(stationData.air_temperature).toFixed(1) : '-';
                                            const isRainy = !!(stationData && Number(stationData.rain) > 0);
                                            const isSunny = !!(stationData && Number(stationData.solar) >= 3);
                                            const isNight = !!(stationData && Number(stationData.solar) < 3);
                                            const addressStationL = stationData ? Number(stationData.addressStation) : null;

                                            return (
                                                <button
                                                    key={hour}
                                                    className={`historyCard ${isSelected ? 'selected' : ''}`}
                                                    onClick={() => this.handleCardClick(hour)}
                                                    disabled={isDisabled}
                                                    style={{
                                                        backgroundColor: isSelected ? 'rgb(250, 125, 52)' : 'rgb(32 35 39)',
                                                        color: isDisabled ? 'gray' : 'white',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <div>{String(hour).padStart(2, '0')}:00</div>
                                                    <>
                                                        {addressStationL === 255 ? (
                                                            isRainy ? (
                                                                isNight ? (
                                                                    <img style={{ width: '1rem' }} src={rainNight} alt='Chuva à noite' />
                                                                ) : (
                                                                    <img style={{ width: '1rem' }} src={rainDay} alt='Chuva durante o dia' />
                                                                )
                                                            ) : (
                                                                isSunny ? (
                                                                    <img style={{ width: '1rem' }} src={sun} alt="Sol" />
                                                                ) : (
                                                                    isNight ? (
                                                                        <img style={{ width: '1rem' }} src={lua} alt="Lua" />
                                                                    ) : null
                                                                )
                                                            )
                                                        ) : addressStationL === 200 && isRainy ? (
                                                            <img style={{ width: '1rem' }} src={chuva} alt='Chuva' />
                                                        ) : null}
                                                    </>
                                                    <div>
                                                        {temperature !== '-' ? (
                                                            <div>
                                                                <span style={{ fontSize: '0.75rem' }}>{temperature}</span>
                                                                <span style={{ fontSize: '0.625rem' }}>°C</span>
                                                            </div>
                                                        ) : (
                                                            <span>-</span>
                                                        )}
                                                    </div>
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            }
                            <div style={{ backgroundColor: 'rgb(52, 58, 64)', marginTop: '0.5rem', height: '22.5rem', borderRadius: '0.5rem' }}>
                                <div className="configurationDataContainer">
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <h3 className="titleHistoric">{res.HISTORICO}</h3>
                                        <Tabs
                                            value={selectedHistoricType}
                                            onChange={this.handleTabHistoricChange}
                                            classes={{ indicator: classes.tabsIndicator }}
                                            style={{ background: 'rgb(32 35 39)', borderRadius: '2rem', margin: '0.5rem 0.5rem 0 0.5rem', color: 'lightgray', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }}
                                        >
                                            <Tab onClick={() => this.handleTabClick('weatherChart')} style={{ minWidth: '5rem', padding: '0 1rem', margin: '1rem 0', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: classes.tab }} value='daily' label={res.DIARIO} />
                                            <Tab onClick={() => this.handleTabClick('temperatureWeek')} style={{ minWidth: '5rem', padding: '0 1rem', margin: '1rem 0', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: classes.tab }} value='week' label={res.SEMANAL} />
                                            <Tab onClick={() => this.handleTabClick('temperatureMonth')} style={{ minWidth: '5rem', padding: '0 1rem', margin: '1rem 0', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: classes.tab }} value='month' label={res.MENSAL} />
                                            <Tab onClick={() => this.handleTabClick('temperatureYear')} style={{ minWidth: '5rem', padding: '0 1rem', margin: '1rem 0', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: classes.tab }} value='year' label={res.ANUAL} />
                                        </Tabs>
                                    </div>
                                    <div className="selectStationContainer">
                                        <div style={{ width: '100%', display: 'flex' }}>
                                            <div className="dateContainer">
                                                <div style={{ textAlign: 'center' }}>
                                                    {loading ? (
                                                        <>
                                                            {selectedHistoricType === 'daily' ? (
                                                                <Skeleton
                                                                    variant="text"
                                                                    style={{ margin: '0 1rem' }}
                                                                    width={200}
                                                                    height={32}
                                                                />
                                                            ) : selectedHistoricType === 'month' ? (
                                                                <Skeleton
                                                                    variant="text"
                                                                    style={{ margin: '0 1rem' }}
                                                                    width={200}
                                                                    height={32}
                                                                />
                                                            ) : selectedHistoricType === 'week' ? (
                                                                <>
                                                                    <Skeleton
                                                                        variant="text"
                                                                        style={{ margin: '0 1rem' }}
                                                                        width={200}
                                                                        height={32}
                                                                    />
                                                                    <Skeleton
                                                                        variant="text"
                                                                        style={{ margin: '0 1rem' }}
                                                                        width={200}
                                                                        height={32}
                                                                    />
                                                                </>
                                                            ) : (
                                                                <Skeleton
                                                                    variant="text"
                                                                    style={{ margin: '0 1rem' }}
                                                                    width={200}
                                                                    height={32}
                                                                />
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {selectedHistoricType === 'daily' ? (
                                                                <TextField
                                                                    style={{ margin: '0 1rem', width: '12.5rem' }}
                                                                    id="selectedDate"
                                                                    type="date"
                                                                    InputProps={{
                                                                        inputProps: {
                                                                            max: maxSelectedDate
                                                                        },
                                                                        className: classes.inputDate
                                                                    }}
                                                                    onChange={this.handleDateChange}
                                                                    value={selectedDate}
                                                                    className="inputDate"
                                                                />
                                                            ) : selectedHistoricType === 'month' ? (
                                                                <TextField
                                                                    style={{ margin: '0 1rem', width: '12.5rem' }}
                                                                    id="selectedMonth"
                                                                    type="month"
                                                                    InputProps={{
                                                                        inputProps: {
                                                                            max: maxSelectedDate
                                                                        },
                                                                        className: classes.inputDate
                                                                    }}
                                                                    onChange={this.handleMonthChange}
                                                                    value={selectedMonth}
                                                                    className="inputDate"
                                                                />
                                                            ) : selectedHistoricType === 'week' ? (
                                                                <>
                                                                    <TextField
                                                                        style={{ margin: '0 1rem', width: '12.5rem' }}
                                                                        id="selectedWeekStart"
                                                                        type="date"
                                                                        InputProps={{
                                                                            inputProps: {
                                                                                max: maxSelectedDate
                                                                            },
                                                                            className: classes.inputDate
                                                                        }}
                                                                        onChange={this.handleWeekChange}
                                                                        value={selectedWeekStart}
                                                                        className="inputDate"
                                                                    />
                                                                    <TextField
                                                                        style={{ margin: '0 1rem', width: '12.5rem' }}
                                                                        id="selectedWeekEnd"
                                                                        type="date"
                                                                        InputProps={{
                                                                            inputProps: {
                                                                                readOnly: true
                                                                            },
                                                                            className: classes.inputDate
                                                                        }}
                                                                        value={selectedWeekEnd}
                                                                        className="inputDate"
                                                                    />
                                                                </>
                                                            ) : (
                                                                <Select
                                                                    className={classes.select}
                                                                    value={selectedYear}
                                                                    onChange={this.handleYearChange}
                                                                    inputProps={{
                                                                        classes: {
                                                                            icon: classes.icon,
                                                                        },
                                                                    }}
                                                                >
                                                                    {Array.from({ length: 10 }, (_, i) => (
                                                                        <MenuItem
                                                                            key={i}
                                                                            value={new Date().getFullYear() - i}
                                                                            className={classes.menuItem}
                                                                        >
                                                                            {new Date().getFullYear() - i}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                                <div style={{ display: 'flex', textAlign: 'center' }}>
                                                    <Button
                                                        style={{
                                                            height: '1.5rem',
                                                            background: loading ? 'rgb(32 35 39)' : 'rgb(250, 125, 52)',
                                                            width: '4.25rem',
                                                            borderRadius: '1rem',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            lineHeight: '0',
                                                            color: loading ? 'lightgray' : 'white',
                                                            margin: '0 0.5rem'
                                                        }}
                                                        className="dateButton"
                                                        variant="contained"
                                                        onClick={
                                                            selectedHistoricType === 'daily'
                                                                ? this.handleFilterDate
                                                                : selectedHistoricType === 'month'
                                                                    ? this.readWeatherDataByMonth
                                                                    : selectedHistoricType === 'week'
                                                                        ? this.readWeatherDataByWeek
                                                                        : this.readWeatherDataByYear
                                                        }
                                                        disabled={loading ? 'disabled' : null}
                                                    >
                                                        {res.FILTRAR}
                                                    </Button>
                                                    <Button
                                                        style={{
                                                            height: '1.5rem',
                                                            background: 'rgb(32 35 39)',
                                                            width: '4.25rem',
                                                            borderRadius: '1rem',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            lineHeight: '0',
                                                        }}
                                                        disabled={loading ? 'disabled' : null}
                                                        className='restartFilterButton' title={res.REINICIAR_FILTRO} onClick={this.clearFilters} variant="contained">
                                                        <RestartIcon style={{ color: loading ? 'lightgray' : 'white' }} />
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {selectedHistoricType === 'daily' ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', margin: '0 0.5rem', flexDirection: 'column' }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                            <Tabs
                                                style={{ background: 'rgb(32 35 39)', borderRadius: '2rem', color: filterStations.length > 0 ? 'lightgray' : 'gray', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }}
                                                value={selectedInfo}
                                                onChange={filterStations.length > 0 ? this.handleTabChange : null}
                                                classes={{
                                                    indicator: classes.tabsIndicator
                                                }}
                                                variant="scrollable"
                                                scrollButtons="auto"
                                            >
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: filterStations.length === 0 ? classes.tabDisabled : classes.tab }} label={res.CLIMA} value="weatherChart" disabled={filterStations.length === 0} />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: filterStations.length === 0 ? classes.tabDisabled : classes.tab }} label={tools.replaceString(res._TEMPERATURA_UNI, res.C)} value="temperature" disabled={filterStations.length === 0} />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: filterStations.length === 0 ? classes.tabDisabled : classes.tab }} label={res.HUMIDADE_UNI} value="humidity" disabled={filterStations.length === 0} />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: filterStations.length === 0 ? classes.tabDisabled : classes.tab }} label={res.PRESSAO_UNI} value="pressure" disabled={filterStations.length === 0} />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: filterStations.length === 0 ? classes.tabDisabled : classes.tab }} label={res.DIRECAO_VENTO_UNI} value="wind_direction" disabled={filterStations.length === 0} />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: filterStations.length === 0 ? classes.tabDisabled : classes.tab }} label={`${res.VENTO_VELOCIDADE} (${windSpeedUnit === 'km/h' ? ' km/h' : ' m/s'})`} value="wind_speed" disabled={filterStations.length === 0} />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: filterStations.length === 0 ? classes.tabDisabled : classes.tab }} label={res.DELTA_T} value="delta_t" disabled={filterStations.length === 0} />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: filterStations.length === 0 || temperatureL === 'Sem conexão' ? classes.tabDisabled : classes.tab }} label={res.INVERSAO_TERMICA} value="thermalInversion" disabled={filterStations.length === 0 || temperatureL === 'Sem conexão' || thermalInversionL === 'Desabilitado'} />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: filterStations.length === 0 ? classes.tabDisabled : hasRain ? classes.tab : classes.tabDisabled }} label={res.CHUVA} value="rain" disabled={!hasRain || filterStations.length === 0} />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: filterStations.length === 0 ? classes.tabDisabled : hasSolar ? classes.tab : classes.tabDisabled }} label={res.RADIACAO_SOLAR} value="solar" disabled={!hasSolar || filterStations.length === 0} />
                                            </Tabs>
                                        </div>
                                        <div>
                                            {this.showChart()}
                                        </div>
                                    </div>
                                ) : selectedHistoricType === 'month' ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', margin: '0 0.5rem', flexDirection: 'column' }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                            <Tabs
                                                style={{ background: 'rgb(32 35 39)', borderRadius: '2rem', color: 'lightgray', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }}
                                                value={selectedInfo}
                                                onChange={this.handleTabChange}
                                                classes={{
                                                    indicator: classes.tabsIndicator
                                                }}
                                            >
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: monthlyData.length === 0 ? classes.tabDisabled : classes.tab }} label={tools.replaceString(res._TEMPERATURA_UNI, res.C)} value="temperatureMonth" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: monthlyData.length === 0 ? classes.tabDisabled : classes.tab }} label={res.HUMIDADE_UNI} value="humidityMonth" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: monthlyData.length === 0 ? classes.tabDisabled : classes.tab }} label={res.PRESSAO_UNI} value="pressureMonth" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: monthlyData.length === 0 ? classes.tabDisabled : classes.tab }} label={`${res.VENTO_VELOCIDADE} (${windSpeedUnit === 'km/h' ? ' km/h' : ' m/s'})`} value="windSpeedMonth" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: monthlyData.length === 0 ? classes.tabDisabled : classes.tab }} label={res.CHUVA} value="rainMonth" />
                                            </Tabs>
                                        </div>
                                        <div>
                                            {this.showChart()}
                                        </div>
                                    </div>
                                ) : selectedHistoricType === 'week' ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', margin: '0 0.5rem', flexDirection: 'column' }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                            <Tabs
                                                style={{ background: 'rgb(32 35 39)', borderRadius: '2rem', color: 'lightgray', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }}
                                                value={selectedInfo}
                                                onChange={this.handleTabChange}
                                                classes={{
                                                    indicator: classes.tabsIndicator
                                                }}
                                            >
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: weeklyData.length === 0 ? classes.tabDisabled : classes.tab }} label={tools.replaceString(res._TEMPERATURA_UNI, res.C)} value="temperatureWeek" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: weeklyData.length === 0 ? classes.tabDisabled : classes.tab }} label={res.HUMIDADE_UNI} value="humidityWeek" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: weeklyData.length === 0 ? classes.tabDisabled : classes.tab }} label={res.PRESSAO_UNI} value="pressureWeek" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: weeklyData.length === 0 ? classes.tabDisabled : classes.tab }} label={`${res.VENTO_VELOCIDADE} (${windSpeedUnit === 'km/h' ? ' km/h' : ' m/s'})`} value="windSpeedWeek" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: weeklyData.length === 0 ? classes.tabDisabled : classes.tab }} label={res.CHUVA} value="rainWeek" />
                                            </Tabs>
                                        </div>
                                        <div>
                                            {this.showChart()}
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{ display: 'flex', justifyContent: 'center', margin: '0 0.5rem', flexDirection: 'column' }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                            <Tabs
                                                style={{ background: 'rgb(32 35 39)', borderRadius: '2rem', color: 'lightgray', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }}
                                                value={selectedInfo}
                                                onChange={this.handleTabChange}
                                                classes={{
                                                    indicator: classes.tabsIndicator
                                                }}
                                            >
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: yearlyData.length === 0 ? classes.tabDisabled : classes.tab }} label={tools.replaceString(res._TEMPERATURA_UNI, res.C)} value="temperatureYear" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: yearlyData.length === 0 ? classes.tabDisabled : classes.tab }} label={res.HUMIDADE_UNI} value="humidityYear" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: yearlyData.length === 0 ? classes.tabDisabled : classes.tab }} label={res.PRESSAO_UNI} value="pressureYear" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: yearlyData.length === 0 ? classes.tabDisabled : classes.tab }} label={`${res.VENTO_VELOCIDADE} (${windSpeedUnit === 'km/h' ? ' km/h' : ' m/s'})`} value="windSpeedYear" />
                                                <Tab style={{ minWidth: '5rem', padding: '0 1rem', minHeight: '0', height: '2rem', display: 'flex', alignItems: 'center' }} classes={{ root: yearlyData.length === 0 ? classes.tabDisabled : classes.tab }} label={res.CHUVA} value="rainYear" />
                                            </Tabs>
                                        </div>
                                        <div>
                                            {this.showChart()}
                                        </div>
                                    </div>
                                )}
                            </div>
                            {loading ?
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div className="weatherCard">
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            width={120}
                                            height={32}
                                        />
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            height={160}
                                            width={120}
                                        />
                                    </div>
                                    <div className="weatherCard">
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            width={120}
                                            height={32}
                                        />
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            height={160}
                                            width={120}
                                        />
                                    </div>
                                    <div className="weatherCard">
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            width={120}
                                            height={32}
                                        />
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            height={160}
                                            width={120}
                                        />
                                    </div>
                                    <div className="weatherCard">
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            width={120}
                                            height={32}
                                        />
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            height={160}
                                            width={120}
                                        />
                                    </div>
                                    <div className="weatherCard">
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            width={120}
                                            height={32}
                                        />
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            height={160}
                                            width={120}
                                        />
                                    </div>
                                    <div className="weatherCard">
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            width={120}
                                            height={32}
                                        />
                                        <Skeleton
                                            variant="text"
                                            style={{ margin: "0" }}
                                            height={160}
                                            width={120}
                                        />
                                    </div>
                                </div>
                                :
                                <div style={{ display: 'flex' }}>
                                    <div className="weatherCard">
                                        <div style={{
                                            backgroundColor: 'rgb(250, 125, 52)',
                                            borderRadius: '50%',
                                            width: '2rem',
                                            height: '2rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            position: 'absolute',
                                            top: '46.25rem',
                                            zIndex: 2
                                        }}>
                                            <img style={{ width: '1.5rem', height: '1.5rem' }} title='Inversão térmica' src={thermalInversion} alt="thermal inversion icon" />
                                        </div>
                                        <div style={{ display: 'flex', textAlign: 'center', paddingTop: '1rem' }}>
                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.INVERSAO_TERMICA}</h3>
                                            <Tooltip
                                                title={
                                                    <div
                                                        style={{
                                                            backgroundColor: '#fff',
                                                            padding: '10px',
                                                            borderRadius: '4px',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                            width: '25.25rem'
                                                        }}
                                                    >
                                                        {thermalInversionL === "Não está ocorrendo inversão térmica" || "Desabilitado"
                                                            ?
                                                            <img style={{ marginTop: '2.5rem', maxHeight: '12rem', borderRadius: '1rem' }} src={normalFlowExample} alt="Fluxo normal" />
                                                            :
                                                            <img style={{ marginTop: '2.5rem', maxHeight: '12rem', borderRadius: '1rem' }} src={thermalInversionExample} alt="Fluxo com inversão térmica" />
                                                        }

                                                    </div>
                                                }
                                                placement="top"
                                                arrow
                                                classes={{ tooltip: classes.customWidthTooltip }}
                                            >
                                                <HelpOutlineIcon style={{ color: 'rgb(250, 125, 52)', marginBottom: '0', width: '1.25rem', marginLeft: '0.5rem' }} />
                                            </Tooltip>
                                        </div>
                                        <span style={{ color: 'white', fontSize: '1rem', textAlign: 'center' }}>{thermalInversionL}</span>
                                    </div>
                                    <div className="weatherCard">
                                        <div style={{
                                            backgroundColor: 'rgb(250, 125, 52)',
                                            borderRadius: '50%',
                                            width: '2rem',
                                            height: '2rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            position: 'absolute',
                                            top: '46.25rem',
                                            zIndex: 2
                                        }}>
                                            <img style={{ width: '1.5rem', height: '1.5rem' }} title='Latitude' src={latitude} alt="latitude icon" />
                                        </div>
                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.LATITUDE}</h3>
                                            <h4 style={{ color: 'rgb(250, 125, 52)', whiteSpace: 'nowrap' }}>{`(${res.GRAUS_MINUTOS_SEGUNDOS})`}</h4>
                                        </div>
                                        <span style={{ color: 'white', fontSize: '1.25rem' }}>{latL.input}</span>
                                    </div>
                                    <div className="weatherCard">
                                        <div style={{
                                            backgroundColor: 'rgb(250, 125, 52)',
                                            borderRadius: '50%',
                                            width: '2rem',
                                            height: '2rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            position: 'absolute',
                                            top: '46.25rem',
                                            zIndex: 2
                                        }}>
                                            <img style={{ width: '1.5rem', height: '1.5rem' }} title='Longitude' src={longitude} alt="longitude icon" />
                                        </div>
                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.LONGITUDE}</h3>
                                            <h4 style={{ color: 'rgb(250, 125, 52)', whiteSpace: 'nowrap' }}>{`(${res.GRAUS_MINUTOS_SEGUNDOS})`}</h4>
                                        </div>
                                        <span style={{ color: 'white', fontSize: '1.25rem' }}>{lngL.input}</span>
                                    </div>
                                    <div className="weatherCard">
                                        <div style={{
                                            backgroundColor: 'rgb(250, 125, 52)',
                                            borderRadius: '50%',
                                            width: '2rem',
                                            height: '2rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            position: 'absolute',
                                            top: '46.25rem',
                                            zIndex: 2
                                        }}>
                                            <img style={{ width: '1.5rem', height: '1.5rem' }} title='Altitude' src={altitude} alt="altitude icon" />
                                        </div>
                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.ALTITUDE}</h3>
                                            <h4 style={{ color: 'rgb(250, 125, 52)' }}>{`(${res.METROS})`}</h4>
                                        </div>
                                        <span style={{ color: 'white', fontSize: '1.25rem' }}>{heightL === 'Sem conexão' ? 'Sem conexão' : `${heightL} m`}</span>
                                    </div>
                                    <div className="weatherCard">
                                        <div style={{
                                            backgroundColor: 'rgb(250, 125, 52)',
                                            borderRadius: '50%',
                                            width: '2rem',
                                            height: '2rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            position: 'absolute',
                                            top: '46.25rem',
                                            zIndex: 2
                                        }}>
                                            <img style={{ width: '1.5rem', height: '1.5rem' }} title='Pressão' src={pressure} alt="pressure icon" />
                                        </div>
                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.PRESSAO}</h3>
                                            <h4 style={{ color: 'rgb(250, 125, 52)' }}>{`(${res.HECTOPASCAL})`}</h4>
                                        </div>
                                        <span style={{ color: 'white', fontSize: '1.25rem' }}>{pressureL === 'Sem conexão' ? 'Sem conexão' : `${pressureL} hPa `}</span>
                                    </div>
                                    <div className="weatherCard" style={{ margin: '0.5rem 0' }}>
                                        <div style={{
                                            backgroundColor: 'rgb(250, 125, 52)',
                                            borderRadius: '50%',
                                            width: '2rem',
                                            height: '2rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            position: 'absolute',
                                            top: '46.25rem',
                                            zIndex: 2
                                        }}>
                                            <img style={{ width: '1.5rem', height: '1.5rem' }} title='Condições climáticas' src={condicoes_climaticas} alt="condicoes climaticas icon" />
                                        </div>
                                        <div>
                                            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                                <h3 style={{ color: 'rgb(250, 125, 52)', textAlign: 'center' }}>{res.SENSORES}</h3>
                                            </div>
                                        </div>
                                        {addressStationL === 255 || addressStationL === 200 ? (
                                            <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '1.5rem', width: '100%' }}>
                                                <img
                                                    className="modulesIcon"
                                                    title={res.SENSOR_CHUVA_ATIVADO}
                                                    src={rainOn}
                                                    alt="rain icon"
                                                />
                                                {addressStationL === 255 ? (
                                                    <img
                                                        className="modulesIcon"
                                                        title={res.SENSOR_RADIACAO_SOLAR_ATIVADO}
                                                        src={solarOn}
                                                        alt="solar icon"
                                                    />
                                                ) : (
                                                    <img
                                                        className="modulesIcon"
                                                        title={res.SENSOR_RADIACAO_SOLAR_DESATIVADO}
                                                        src={solarOff}
                                                        alt="solar icon"
                                                    />
                                                )}
                                            </div>
                                        ) : (
                                            <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%' }}>
                                                <img
                                                    className="modulesIcon"
                                                    title={res.SENSOR_CHUVA_DESATIVADO}
                                                    src={rainOff}
                                                    alt="rain icon"
                                                />
                                                <img
                                                    className="modulesIcon"
                                                    title={res.SENSOR_RADIACAO_SOLAR_DESATIVADO}
                                                    src={solarOff}
                                                    alt="solar icon"
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                        </div>

                        <div style={{ width: '21.75%' }}>
                            <div className="divContent divRelative map-p" style={{ backgroundColor: 'rgb(52, 58, 64)', height: '16rem', minWidth: '22rem', padding: '0', borderRadius: '0.5rem' }}>
                                <div className="containerTop" style={{ padding: '0' }}></div>
                                <div className={`wrapperMap ${isMapExpanded ? classes.expandedMapStyles : {}}`}>
                                    <div style={{ width: '100%', height: '100%', position: 'absolute', zIndex: '1111', display: !disable ? 'none' : 'block' }}></div>

                                    <div id="mapid" className={classes.mapCommonStyle}></div>
                                    <div className="zoom" style={!isMapExpanded ? { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' } : undefined}>
                                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '0.25rem' }}>
                                            <Button className="buttonS buttonMenu" onClick={() => this.zoomInL()}>
                                                <MaterialIcon icon="add" className="iconMap" />
                                            </Button>
                                            <Button className="buttonS buttonMenu" onClick={() => this.zoomOutL()}>
                                                <MaterialIcon icon="remove" className="iconMap" />
                                            </Button>
                                        </div>

                                        {isMapExpanded ?
                                            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '0.25rem' }}>
                                                <Button className={goTo === true ? "buttonS buttonMenuWeather" : "buttonS buttonMenu"} title={res.LOCALIZAR_ESTACAO} onClick={() => this.showGoTo()}>
                                                    <MaterialIcon icon="search" className="iconMap" />
                                                </Button>
                                                <Button className={consultForecastData === true ? "buttonS buttonMenuWeather" : "buttonS buttonMenu"} title={res.PREVISAO_TEMPO} onClick={() => this.consultForecast()}>
                                                    <FilterDramaIcon className="iconMap" />
                                                </Button>
                                                <Button className={showData === true ? "buttonS buttonMenuWeather" : "buttonS buttonMenu"} title={`${res.DADOS_ESTACAO} ${nameL}`} onClick={() => this.showMapData()}>
                                                    <img style={{ width: '2rem', height: '2rem' }} src={weatherData} alt="Dados da estação icon" />

                                                </Button>
                                            </div>
                                            : null
                                        }

                                        <Button
                                            className={`buttonS ${consultForecastData ? 'buttonMenuWeather' : 'buttonMenu'} ${isMapExpanded ? classes.buttonFullScreenStyles : classes.buttonNormalStyles}`}
                                            title={isMapExpanded ? res.DIMINUIR_TELA : res.AUMENTAR_TELA}
                                            onClick={this.toggleMapSize}
                                        >
                                            {isMapExpanded ? <FullscreenExitIcon className="iconMap" /> : <FullscreenIcon className="iconMap" />}
                                        </Button>

                                        {isMapExpanded && showData ?
                                            <div style={{ display: 'flex', flexDirection: 'column', position: 'fixed', left: '0', right: '0', bottom: '0.5rem', margin: '0 0.5rem', backgroundColor: 'rgba(52, 58, 64, 0.85)', justifyContent: 'space-around' }}>
                                                <h3 style={{ margin: '0', textAlign: 'center', color: 'white', fontSize: '1.25rem' }}>{nameL}</h3>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="weatherData">
                                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.TEMPERATURA_}</h3>
                                                            <h4 style={{ color: 'rgb(250, 125, 52)', whiteSpace: 'nowrap' }}>{`(${res.GRAU_CELSIUS})`}</h4>
                                                        </div>
                                                        <span style={{ color: 'white', fontSize: '1.25rem' }}>{air_temperatureL} °C</span>
                                                    </div>
                                                    <div className="weatherData">
                                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.UMIDADE_}</h3>
                                                            <h4 style={{ color: 'rgb(250, 125, 52)', whiteSpace: 'nowrap' }}>{`(${res.PERCENTUAL})`}</h4>
                                                        </div>
                                                        <span style={{ color: 'white', fontSize: '1.25rem' }}>{air_humidityL} %</span>
                                                    </div>
                                                    <div className="weatherData">
                                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.VENTO_VELOCIDADE}</h3>
                                                            <h4 style={{ color: 'rgb(250, 125, 52)', whiteSpace: 'nowrap' }}>{`(${res.KM_H})`}</h4>
                                                        </div>
                                                        <span style={{ color: 'white', fontSize: '1.25rem' }}>{wind_speedL} {windSpeedUnit === 'km/h' ? 'km/h' : 'm/s'}</span>
                                                    </div>
                                                    <div className="weatherData">
                                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.DELTA_T}</h3>
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                                                            <span style={{ color: 'white', fontSize: '1.25rem' }}>{delta_tL}</span>
                                                            <span style={{ color: 'white', fontSize: '1rem' }}>{flightConditions}</span>
                                                        </div>
                                                    </div>
                                                    <div className="weatherData">
                                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.DIRECAO_VENTO}</h3>
                                                            <h4 style={{ color: 'rgb(250, 125, 52)', whiteSpace: 'nowrap' }}>{`(${res.GRAUS})`}</h4>

                                                        </div>
                                                        <span style={{ color: 'white', fontSize: '1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                                                            <p style={{ marginRight: '1rem', marginBottom: '0' }}>{`${wind_directionL} °`}</p>
                                                            <div className="windDirectionIcon">
                                                                <div className="circle">
                                                                    <div className="windDirection north">N</div>
                                                                    <div className="windDirection south">S</div>
                                                                    <div className="windDirection east">L</div>
                                                                    <div className="windDirection west">O</div>
                                                                </div>
                                                                <div className="windDirectionArrow" style={{ transform: `rotate(${wind_directionL}deg)`, padding: '0.5rem 0 0.25rem 0' }}>
                                                                    <NavigationIcon style={{ fontSize: '1rem', color: 'white' }} />
                                                                </div>
                                                            </div>
                                                        </span>
                                                    </div>
                                                    <div className="weatherData">
                                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.INVERSAO_TERMICA}</h3>
                                                        </div>
                                                        <span style={{ color: 'white', fontSize: '1rem', textAlign: 'center' }}>{thermalInversionL}</span>
                                                    </div>
                                                    <div className="weatherData">
                                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.LATITUDE}</h3>
                                                            <h4 style={{ color: 'rgb(250, 125, 52)', whiteSpace: 'nowrap' }}>{`(${res.GRAUS_MINUTOS_SEGUNDOS})`}</h4>
                                                        </div>
                                                        <span style={{ color: 'white', fontSize: '1.25rem' }}>{latL.input}</span>
                                                    </div>
                                                    <div className="weatherData">
                                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.LONGITUDE}</h3>
                                                            <h4 style={{ color: 'rgb(250, 125, 52)', whiteSpace: 'nowrap' }}>{`(${res.GRAUS_MINUTOS_SEGUNDOS})`}</h4>
                                                        </div>
                                                        <span style={{ color: 'white', fontSize: '1.25rem' }}>{lngL.input}</span>
                                                    </div>
                                                    <div className="weatherData">
                                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.ALTITUDE}</h3>
                                                            <h4 style={{ color: 'rgb(250, 125, 52)' }}>{`(${res.METROS})`}</h4>
                                                        </div>
                                                        <span style={{ color: 'white', fontSize: '1.25rem' }}>{heightL === 'Sem conexão' ? 'Sem conexão' : `${heightL} m`}</span>
                                                    </div>
                                                    <div className="weatherData" style={{ border: 'none' }}>
                                                        <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                                            <h3 style={{ color: 'rgb(250, 125, 52)', marginBottom: '0' }}>{res.PRESSAO}</h3>
                                                            <h4 style={{ color: 'rgb(250, 125, 52)' }}>{`(${res.HECTOPASCAL})`}</h4>
                                                        </div>
                                                        <span style={{ color: 'white', fontSize: '1.25rem' }}>{pressureL === 'Sem conexão' ? 'Sem conexão' : `${pressureL} hPa `}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                        {isMapExpanded && showData ?
                                            <div
                                                id="divFloat"
                                                className="div-list divContentList "
                                                style={{
                                                    backgroundColor: 'rgba(52, 58, 64, 0.85)',
                                                    marginTop: '0.5rem',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    height: '27rem',
                                                    width: '20rem',
                                                    position: 'fixed',
                                                    borderRadius: '0.5rem 0.5rem 0 0',
                                                    left: '0.5rem',
                                                    bottom: '11.35rem',
                                                }}
                                                onMouseEnter={() => this.toggleHoverForecast(true)}
                                                onMouseLeave={() => this.toggleHoverForecast(false)}
                                            >
                                                <div style={{ textAlign: 'center', padding: '0.5rem' }}>
                                                    <h3 className="titleWeatherForecast">{res.PREVISAO_TEMPO}</h3>
                                                </div>
                                                {weatherForecastData.length === 0
                                                    ?
                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                        <Skeleton style={{ margin: '0.5rem' }} variant="text" width={210} height={40} />
                                                        <Skeleton style={{ margin: '0.5rem' }} variant="text" width={210} height={40} />
                                                        <Skeleton style={{ margin: '0.5rem' }} variant="text" width={210} height={40} />
                                                        <Skeleton style={{ margin: '0.5rem' }} variant="text" width={210} height={40} />
                                                        <Skeleton style={{ margin: '0.5rem' }} variant="text" width={210} height={40} />
                                                    </div>
                                                    :
                                                    <div className="bodyListStations" style={{ maxHeight: '23rem' }}>
                                                        <List component="nav" aria-labelledby="areas" className="weatherListContainer" style={{ padding: '0' }}>
                                                            {weatherForecastData.map((weather) => {
                                                                return (
                                                                    <ListItem key={weather.id} style={{ padding: '0.25rem 0.5rem 0.5rem 0.5rem' }}>
                                                                        <ListItemText id={weather.id} style={{ padding: '0 0.5rem', margin: '0', backgroundColor: 'rgb(32 35 39)', borderRadius: '1rem' }}>
                                                                            <ul style={{ padding: '0', margin: '0' }}>
                                                                                <li className='weatherListItem'>
                                                                                    <input type='checkbox' id={weather.weatherData[0].dt} className='inputWeatherForecast' />
                                                                                    <label for={weather.weatherData[0].dt} className='labelWeatherForecast'>
                                                                                        {Moment(weather.date).format("DD/MM")}
                                                                                        {weather.climateConditions === 'Clouds' ? <img style={{ maxHeight: '2rem' }} title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                            return a.toUpperCase();
                                                                                        })} src={cloud} alt="cloud" />
                                                                                            : weather.climateConditions === 'Rain' ? <img style={{ maxHeight: '2rem' }} title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                                return a.toUpperCase();
                                                                                            })} src={rainOn} alt="rain" />
                                                                                                : <img style={{ maxHeight: '2rem' }} title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                                    return a.toUpperCase();
                                                                                                })} src={sun} alt="sun" />
                                                                                        }
                                                                                        {`${weather.minTemp.toFixed(0)}° / ${weather.maxTemp.toFixed(0)}°`}
                                                                                        <ChevronRightIcon className='arrowIcon' fontSize='medium' />
                                                                                    </label>
                                                                                    <div className='weatherListData'>
                                                                                        {weather.weatherData.map((item) => (
                                                                                            <ul key={item.dt} style={{ padding: '0.5rem', margin: '0' }}>
                                                                                                <li className='forecastInformation'>
                                                                                                    <b style={{ color: 'rgb(250, 125, 52)' }} >{Moment(item.dt_txt).format("HH")}h:</b>
                                                                                                    <ul style={{ padding: '0.5rem' }}>
                                                                                                        <li className='forecastInformation'>
                                                                                                            <img style={{ maxHeight: '2rem', marginRight: '0.5rem' }} title='Temperatura' src={temperatureForecast} alt="temperature forecast" />
                                                                                                            {item.main.temp.toFixed(0)} °C
                                                                                                        </li>
                                                                                                        <li className='forecastInformation'>
                                                                                                            <img style={{ maxHeight: '2rem', marginRight: '0.5rem' }} title='Umidade' src={humidityForecast} alt="humidity forecast" />
                                                                                                            {item.main.humidity} %
                                                                                                        </li>
                                                                                                        <li className='forecastInformation'>
                                                                                                            <img style={{ maxHeight: '2rem', marginRight: '0.5rem' }} title='Pressão' src={pressureForecast} alt="pressure forecast" />
                                                                                                            {item.main.pressure} hPa
                                                                                                        </li>
                                                                                                        <li className='forecastInformation'>
                                                                                                            <img style={{ maxHeight: '2rem', marginRight: '0.5rem' }} title='Velocidade do vento' src={windSpeedForecast} alt="wind speed forecast" />
                                                                                                            {(Number(item.wind.speed) * 3.6).toFixed(0)} km/h
                                                                                                        </li>
                                                                                                        <li className='forecastInformation' style={{ display: 'flex' }}>
                                                                                                            <img style={{ maxHeight: '2rem', marginRight: '0.5rem' }} title='Direção do vento' src={windDirectionForecast} alt="wind direction forecast" />
                                                                                                            {/* {item.wind.deg} ° */}
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    display: 'flex',
                                                                                                                    alignSelf: 'center',
                                                                                                                    transform: `rotate(${item.wind.deg}deg)`,
                                                                                                                    marginLeft: '0.5rem'
                                                                                                                }}
                                                                                                            >
                                                                                                                <NavigationIcon style={{ fontSize: '1.8rem', transform: `rotate(180deg)`, color: 'white' }} />
                                                                                                            </div>
                                                                                                        </li>
                                                                                                        <li className='forecastInformation'>
                                                                                                            {item.weather[0].main === 'Clouds'
                                                                                                                ?
                                                                                                                <img
                                                                                                                    style={{ maxHeight: '2rem', marginRight: '0.5rem' }}
                                                                                                                    src={cloud}
                                                                                                                    alt="cloud"
                                                                                                                    title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                                                        return a.toUpperCase();
                                                                                                                    })}
                                                                                                                />
                                                                                                                :
                                                                                                                item.weather[0].main === 'Rain'
                                                                                                                    ?
                                                                                                                    <img
                                                                                                                        style={{ maxHeight: '2rem', marginRight: '0.5rem' }}
                                                                                                                        src={rainOn}
                                                                                                                        alt="rain"
                                                                                                                        title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                                                            return a.toUpperCase();
                                                                                                                        })}
                                                                                                                    />
                                                                                                                    :
                                                                                                                    <img
                                                                                                                        style={{ maxHeight: '2rem', marginRight: '0.5rem' }}
                                                                                                                        src={sun}
                                                                                                                        alt="sun"
                                                                                                                        title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                                                            return a.toUpperCase();
                                                                                                                        })}
                                                                                                                    />
                                                                                                            }
                                                                                                            {item.weather[0].description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                                                return a.toUpperCase();
                                                                                                            })}
                                                                                                        </li>
                                                                                                        {item.rain && item.rain['3h'] !== undefined && item.rain['3h'] > 0 ? (
                                                                                                            <li className='forecastInformation'>
                                                                                                                <img
                                                                                                                    style={{ maxHeight: '2rem', marginRight: '0.5rem' }}
                                                                                                                    title='Quantidade de chuva'
                                                                                                                    src={rainForecast}
                                                                                                                    alt='rain forecast'
                                                                                                                />
                                                                                                                {item.rain['3h'].toFixed(2)} mm
                                                                                                            </li>
                                                                                                        ) : (
                                                                                                            ''
                                                                                                        )}
                                                                                                    </ul>
                                                                                                </li>
                                                                                            </ul>
                                                                                        ))}
                                                                                    </div>
                                                                                </li>
                                                                            </ul>
                                                                        </ListItemText>
                                                                    </ListItem>
                                                                );
                                                            })}
                                                        </List>
                                                    </div>
                                                }
                                            </div>
                                            :
                                            null
                                        }
                                    </div>

                                    {goTo ?
                                        <div className="divContent containerToLocate" style={{ width: '15rem', padding: '0' }}>
                                            <div className="modalHeader">
                                                <div className="leftDivHeader"></div>
                                                <div className="centerDivHeader">
                                                    <h3 style={{ color: 'white', margin: '0' }}>{res.LOCALIZAR}</h3>
                                                </div>
                                                <div className="rightDivHeader">
                                                    <Button size="small" className="popUpButton" onClick={() => this.setState({ goTo: false })}>
                                                        <CloseIcon style={{ color: 'white' }} />
                                                    </Button>
                                                </div>
                                            </div>
                                            <div className="locationContainer">
                                                <TextField
                                                    id="lat"
                                                    label={res.LATITUDE}
                                                    margin="normal"
                                                    error={lat.error}
                                                    onChange={this.handleChangeCoordinates('lat')}
                                                    value={lat.input}
                                                    placeholder={geo.toDMS(lat.value, 'latitude', 1)}
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.toString().slice(0, 45)
                                                    }}
                                                />
                                                <TextField
                                                    id="lng"
                                                    label={res.LONGITUDE}
                                                    margin="normal"
                                                    error={lng.error}
                                                    onChange={this.handleChangeCoordinates('lng')}
                                                    value={lng.input}
                                                    placeholder={geo.toDMS(lng.value, 'longitude', 1)}
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.toString().slice(0, 45)
                                                    }}
                                                />
                                                <div className="divForm">
                                                    <Button size="small" className="popUpButton" onClick={() => this.goToCoordinates()}>
                                                        {res.BUSCAR}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                        : ''}
                                </div>
                            </div>

                            <div
                                id="divFloat"
                                className="div-list divContentList"
                                style={{ backgroundColor: 'rgb(52, 58, 64)', marginTop: '0.5rem', display: 'flex', flexDirection: 'column', height: '26.75rem', minWidth: '22rem', borderRadius: '0.5rem' }}
                                onMouseEnter={() => this.toggleHoverForecast(true)}
                                onMouseLeave={() => this.toggleHoverForecast(false)}
                            >
                                <div style={{ textAlign: 'center', padding: '0.5rem' }}>
                                    <h3 className="titleWeatherForecast">{res.PREVISAO_TEMPO}</h3>
                                </div>
                                {weatherForecastData.length === 0
                                    ?
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        <Skeleton style={{ margin: '0.5rem' }} variant="text" width={210} height={40} />
                                        <Skeleton style={{ margin: '0.5rem' }} variant="text" width={210} height={40} />
                                        <Skeleton style={{ margin: '0.5rem' }} variant="text" width={210} height={40} />
                                        <Skeleton style={{ margin: '0.5rem' }} variant="text" width={210} height={40} />
                                        <Skeleton style={{ margin: '0.5rem' }} variant="text" width={210} height={40} />
                                    </div>
                                    :
                                    <div className="bodyListStations" style={{ maxHeight: '23rem', borderRadius: '2rem' }}>
                                        <List component="nav" aria-labelledby="areas" className="weatherListContainer" style={{ padding: '0' }}>
                                            {weatherForecastData.map((weather) => {
                                                return (
                                                    <ListItem key={weather.id} style={{ padding: '0.25rem 0.5rem 0.5rem 0.5rem' }}>
                                                        <ListItemText id={weather.id} style={{ padding: '0 0.5rem', margin: '0', backgroundColor: 'rgb(32 35 39)', borderRadius: '1rem' }}>
                                                            <ul style={{ padding: '0', margin: '0' }}>
                                                                <li className='weatherListItem'>
                                                                    <input type='checkbox' id={weather.weatherData[0].dt} className='inputWeatherForecast' />
                                                                    <label for={weather.weatherData[0].dt} className='labelWeatherForecast'>
                                                                        {Moment(weather.date).format("DD/MM")}
                                                                        {weather.climateConditions === 'Clouds' ? <img style={{ maxHeight: '2rem' }} title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                            return a.toUpperCase();
                                                                        })} src={cloud} alt="cloud" />
                                                                            : weather.climateConditions === 'Rain' ? <img style={{ maxHeight: '2rem' }} title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                return a.toUpperCase();
                                                                            })} src={rainOn} alt="rain" />
                                                                                : <img style={{ maxHeight: '2rem' }} title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                    return a.toUpperCase();
                                                                                })} src={sun} alt="sun" />
                                                                        }
                                                                        {`${weather.minTemp.toFixed(0)}° / ${weather.maxTemp.toFixed(0)}°`}
                                                                        <ChevronRightIcon className='arrowIcon' fontSize='medium' />
                                                                    </label>
                                                                    <div className='weatherListData'>
                                                                        {weather.weatherData.map((item) => (
                                                                            <ul key={item.dt} style={{ padding: '0.5rem', margin: '0' }}>
                                                                                <li className='forecastInformation'>
                                                                                    <b style={{ color: 'rgb(250, 125, 52)' }} >{Moment.utc(item.dt_txt).subtract(3, 'hours').format("HH")}h:</b>
                                                                                    <ul style={{ padding: '0.5rem' }}>
                                                                                        <li className='forecastInformation'>
                                                                                            <img style={{ maxHeight: '2rem', marginRight: '0.5rem' }} title='Temperatura' src={temperatureForecast} alt="temperature forecast" />
                                                                                            {item.main.temp.toFixed(0)} °C
                                                                                        </li>
                                                                                        <li className='forecastInformation'>
                                                                                            <img style={{ maxHeight: '2rem', marginRight: '0.5rem' }} title='Umidade' src={humidityForecast} alt="humidity forecast" />
                                                                                            {item.main.humidity} %
                                                                                        </li>
                                                                                        <li className='forecastInformation'>
                                                                                            <img style={{ maxHeight: '2rem', marginRight: '0.5rem' }} title='Pressão' src={pressureForecast} alt="pressure forecast" />
                                                                                            {item.main.pressure} hPa
                                                                                        </li>
                                                                                        <li className='forecastInformation'>
                                                                                            <img style={{ maxHeight: '2rem', marginRight: '0.5rem' }} title='Velocidade do vento' src={windSpeedForecast} alt="wind speed forecast" />
                                                                                            {(Number(item.wind.speed) * 3.6).toFixed(0)} km/h
                                                                                        </li>
                                                                                        <li className='forecastInformation' style={{ display: 'flex' }}>
                                                                                            <img style={{ maxHeight: '2rem', marginRight: '0.5rem' }} title='Direção do vento' src={windDirectionForecast} alt="wind direction forecast" />
                                                                                            {/* {item.wind.deg} ° */}
                                                                                            <div
                                                                                                style={{
                                                                                                    display: 'flex',
                                                                                                    alignSelf: 'center',
                                                                                                    transform: `rotate(${item.wind.deg}deg)`,
                                                                                                    marginLeft: '0.5rem'
                                                                                                }}
                                                                                            >
                                                                                                <NavigationIcon style={{ fontSize: '1.8rem', transform: `rotate(180deg)`, color: 'white' }} />
                                                                                            </div>
                                                                                        </li>
                                                                                        <li className='forecastInformation'>
                                                                                            {item.weather[0].main === 'Clouds'
                                                                                                ?
                                                                                                <img
                                                                                                    style={{ maxHeight: '2rem', marginRight: '0.5rem' }}
                                                                                                    src={cloud}
                                                                                                    alt="cloud"
                                                                                                    title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                                        return a.toUpperCase();
                                                                                                    })}
                                                                                                />
                                                                                                :
                                                                                                item.weather[0].main === 'Rain'
                                                                                                    ?
                                                                                                    <img
                                                                                                        style={{ maxHeight: '2rem', marginRight: '0.5rem' }}
                                                                                                        src={rainOn}
                                                                                                        alt="rain"
                                                                                                        title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                                            return a.toUpperCase();
                                                                                                        })}
                                                                                                    />
                                                                                                    :
                                                                                                    <img
                                                                                                        style={{ maxHeight: '2rem', marginRight: '0.5rem' }}
                                                                                                        src={sun}
                                                                                                        alt="sun"
                                                                                                        title={weather.description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                                            return a.toUpperCase();
                                                                                                        })}
                                                                                                    />
                                                                                            }
                                                                                            {item.weather[0].description.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
                                                                                                return a.toUpperCase();
                                                                                            })}
                                                                                        </li>
                                                                                        {item.rain && item.rain['3h'] !== undefined && item.rain['3h'] > 0 ? (
                                                                                            <li className='forecastInformation'>
                                                                                                <img
                                                                                                    style={{ maxHeight: '2rem', marginRight: '0.5rem' }}
                                                                                                    title='Quantidade de chuva'
                                                                                                    src={rainForecast}
                                                                                                    alt='rain forecast'
                                                                                                />
                                                                                                {item.rain['3h'].toFixed(2)} mm
                                                                                            </li>
                                                                                        ) : (
                                                                                            ''
                                                                                        )}
                                                                                    </ul>
                                                                                </li>
                                                                            </ul>
                                                                        ))}
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </ListItemText>
                                                    </ListItem>
                                                );
                                            })}
                                        </List>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        );
    }
}

Map.propTypes = {
    classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(Map);

const Box = (props) => {
    const { link, res } = props;
    return (
        <div className="rowForm maxH" style={{ overflow: 'hidden' }}>
            <TextFields1 link={link} res={res} />
        </div>)
}
export default Box;